"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1068],{

/***/ 53989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ handleClientException; },
/* harmony export */   "s": function() { return /* binding */ handleRuntimeError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64487);
/* harmony import */ var services_bigbrain_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65488);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65023);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var handleClientException = function() {
    var _ref = _async_to_generator(function(param) {
        var e, _bbEventParams, bbEventParams, _name, name, params;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = param.e, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. capture exception in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb(e);
                    return [
                        4,
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .flush */ .yl(2000)
                    ];
                case 1:
                    _state.sent();
                    _name = bbEventParams.name, name = _name === void 0 ? constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_3__.CLIENT_EXCEPTION : _name, params = _object_without_properties(bbEventParams, [
                        "name"
                    ]);
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_0__.trackEvent)(name, _object_spread_props(_object_spread({}, params), {
                        placement: window && window.location.href,
                        info1: e && e.message
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function handleClientException(_) {
        return _ref.apply(this, arguments);
    };
}();
var handleRuntimeError = function() {
    var _ref = _async_to_generator(function(errorMessage) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            // 1. capture message in Sentry
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureMessage */ .uT(errorMessage);
            return [
                2
            ];
        });
    });
    return function handleRuntimeError(errorMessage) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 24065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dp": function() { return /* binding */ companySizeValuesList; },
/* harmony export */   "N7": function() { return /* binding */ companySizeList; },
/* harmony export */   "oP": function() { return /* binding */ SMALLEST_COMPANY_SIZE; }
/* harmony export */ });
/* unused harmony exports COMPANY_SIZE_20_49, COMPANY_SIZE_50_99, COMPANY_SIZE_100_250, COMPANY_SIZE_251_1500, COMPANY_SIZE_1500_PLUS */
// Define constants for each company size
var SMALLEST_COMPANY_SIZE = "1-19";
var COMPANY_SIZE_20_49 = "20-49";
var COMPANY_SIZE_50_99 = "50-99";
var COMPANY_SIZE_100_250 = "100-250";
var COMPANY_SIZE_251_1500 = "251-1500";
var COMPANY_SIZE_1500_PLUS = "1500+";
// Use the constants in the data structures
var companySizeList = [
    SMALLEST_COMPANY_SIZE,
    COMPANY_SIZE_20_49,
    COMPANY_SIZE_50_99,
    COMPANY_SIZE_100_250,
    COMPANY_SIZE_251_1500,
    COMPANY_SIZE_1500_PLUS
];
var companySizeValuesList = [
    {
        label: SMALLEST_COMPANY_SIZE,
        value: SMALLEST_COMPANY_SIZE
    },
    {
        label: COMPANY_SIZE_20_49,
        value: COMPANY_SIZE_20_49
    },
    {
        label: COMPANY_SIZE_50_99,
        value: COMPANY_SIZE_50_99
    },
    {
        label: COMPANY_SIZE_100_250,
        value: COMPANY_SIZE_100_250
    },
    {
        label: COMPANY_SIZE_251_1500,
        value: COMPANY_SIZE_251_1500
    },
    {
        label: COMPANY_SIZE_1500_PLUS,
        value: COMPANY_SIZE_1500_PLUS
    }
];


/***/ }),

/***/ 5893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W6": function() { return /* binding */ CHECKBOX_INPUT; },
  "dN": function() { return /* binding */ COMPANY_SIZE_INPUT; },
  "I6": function() { return /* binding */ EMAIL_INPUT; },
  "oo": function() { return /* binding */ FIRSTNAME_INPUT; },
  "Ce": function() { return /* binding */ LASTNAME_INPUT; },
  "wY": function() { return /* binding */ MAXIMUM_LONG_INPUT_LENGTH; },
  "l5": function() { return /* binding */ PHONE_INPUT; },
  "$O": function() { return /* binding */ getInputComponentByType; },
  "Je": function() { return /* binding */ inputTypes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
// EXTERNAL MODULE: ./constants/input-validations-patterns.js
var input_validations_patterns = __webpack_require__(18455);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/common-inputs.scss.js

var commonInputStyles = new String(".hp-input{height:40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:1px solid;border-color:".concat(colors/* default.wolf */.Z.wolf, ";padding:8px;-webkit-transition:border-color.1s ease;-moz-transition:border-color.1s ease;-o-transition:border-color.1s ease;transition:border-color.1s ease;width:100%;&.input-required{position:relative;border-color:").concat(colors/* default.brand-red */.Z["brand-red"], "}&:focus{border-color:").concat(colors/* default.basic-blue */.Z["basic-blue"], "}}"));
commonInputStyles.__hash = "7df3a6382602be4e";

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/text-input/text-input.js










var TextInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextInput);
    function TextInput(props) {
        (0,_class_call_check/* default */.Z)(this, TextInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(TextInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id, defaultValue = _props.defaultValue, translate = _props.translate;
                var inputName = inputData.inputName, type = inputData.type, isRequired = inputData.isRequired, placeholder = inputData.placeholder;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            type: type,
                            placeholder: translate(placeholder),
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            defaultValue: defaultValue,
                            className: "jsx-".concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-text-input", requiredClass) || "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        })
                    ]
                });
            }
        }
    ]);
    return TextInput;
}(react.PureComponent);
TextInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var text_input = ((0,generic_config_context/* withGenericConfig */.P)(TextInput));

;// CONCATENATED MODULE: ./client/components/system/form-inputs/textarea-input/textarea-input.scss.js

var componentStyles = new String(".hp-textarea-input{width:100%;max-width:100%;height:106px;resize:none}");
componentStyles.__hash = "cd455d3ac866b4ba";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/textarea-input/textarea-input.js











var TextareaInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextareaInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextareaInput);
    function TextareaInput(props) {
        (0,_class_call_check/* default */.Z)(this, TextareaInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(TextareaInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, translate = _props.translate, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id, value = _props.value;
                var inputName = inputData.inputName, isRequired = inputData.isRequired, placeholder = inputData.placeholder;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            placeholder: translate(placeholder),
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            value: value,
                            className: "jsx-".concat(componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-textarea-input", requiredClass) || "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return TextareaInput;
}(react.PureComponent);
TextareaInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var textarea_input = ((0,generic_config_context/* withGenericConfig */.P)(TextareaInput));

// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(67555);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input.scss.js
var phone_input_scss_componentStyles = new String(".hp-phone-input{border:0;padding:0}");
phone_input_scss_componentStyles.__hash = "74b374e5521510e1";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input-component.scss.js
var phoneInputStyles = new String('.react-tel-input{font-family:"Roboto",sans-serif;font-size:.844rem;position:relative;width:100%}.react-tel-input :disabled{cursor:not-allowed}.react-tel-input .flag{width:16px;height:11px;background:url(data:image/png;base64,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)}.react-tel-input .ad{background-position:-16px 0}.react-tel-input .ae{background-position:-32px 0}.react-tel-input .af{background-position:-48px 0}.react-tel-input .ag{background-position:-64px 0}.react-tel-input .ai{background-position:-80px 0}.react-tel-input .al{background-position:-96px 0}.react-tel-input .am{background-position:-112px 0}.react-tel-input .ao{background-position:-128px 0}.react-tel-input .ar{background-position:-144px 0}.react-tel-input .as{background-position:-160px 0}.react-tel-input .at{background-position:-176px 0}.react-tel-input .au{background-position:-192px 0}.react-tel-input .aw{background-position:-208px 0}.react-tel-input .az{background-position:-224px 0}.react-tel-input .ba{background-position:-240px 0}.react-tel-input .bb{background-position:0 -11px}.react-tel-input .bd{background-position:-16px -11px}.react-tel-input .be{background-position:-32px -11px}.react-tel-input .bf{background-position:-48px -11px}.react-tel-input .bg{background-position:-64px -11px}.react-tel-input .bh{background-position:-80px -11px}.react-tel-input .bi{background-position:-96px -11px}.react-tel-input .bj{background-position:-112px -11px}.react-tel-input .bm{background-position:-128px -11px}.react-tel-input .bn{background-position:-144px -11px}.react-tel-input .bo{background-position:-160px -11px}.react-tel-input .br{background-position:-176px -11px}.react-tel-input .bs{background-position:-192px -11px}.react-tel-input .bt{background-position:-208px -11px}.react-tel-input .bw{background-position:-224px -11px}.react-tel-input .by{background-position:-240px -11px}.react-tel-input .bz{background-position:0 -22px}.react-tel-input .ca{background-position:-16px -22px}.react-tel-input .cd{background-position:-32px -22px}.react-tel-input .cf{background-position:-48px -22px}.react-tel-input .cg{background-position:-64px -22px}.react-tel-input .ch{background-position:-80px -22px}.react-tel-input .ci{background-position:-96px -22px}.react-tel-input .ck{background-position:-112px -22px}.react-tel-input .cl{background-position:-128px -22px}.react-tel-input .cm{background-position:-144px -22px}.react-tel-input .cn{background-position:-160px -22px}.react-tel-input .co{background-position:-176px -22px}.react-tel-input .cr{background-position:-192px -22px}.react-tel-input .cu{background-position:-208px -22px}.react-tel-input .cv{background-position:-224px -22px}.react-tel-input .cw{background-position:-240px -22px}.react-tel-input .cy{background-position:0 -33px}.react-tel-input .cz{background-position:-16px -33px}.react-tel-input .de{background-position:-32px -33px}.react-tel-input .dj{background-position:-48px -33px}.react-tel-input .dk{background-position:-64px -33px}.react-tel-input .dm{background-position:-80px -33px}.react-tel-input .do{background-position:-96px -33px}.react-tel-input .dz{background-position:-112px -33px}.react-tel-input .ec{background-position:-128px -33px}.react-tel-input .ee{background-position:-144px -33px}.react-tel-input .eg{background-position:-160px -33px}.react-tel-input .er{background-position:-176px -33px}.react-tel-input .es{background-position:-192px -33px}.react-tel-input .et{background-position:-208px -33px}.react-tel-input .fi{background-position:-224px -33px}.react-tel-input .fj{background-position:-240px -33px}.react-tel-input .fk{background-position:0 -44px}.react-tel-input .fm{background-position:-16px -44px}.react-tel-input .fo{background-position:-32px -44px}.react-tel-input .fr,.react-tel-input .bl,.react-tel-input .mf{background-position:-48px -44px}.react-tel-input .ga{background-position:-64px -44px}.react-tel-input .gb{background-position:-80px -44px}.react-tel-input .gd{background-position:-96px -44px}.react-tel-input .ge{background-position:-112px -44px}.react-tel-input .gf{background-position:-128px -44px}.react-tel-input .gh{background-position:-144px -44px}.react-tel-input .gi{background-position:-160px -44px}.react-tel-input .gl{background-position:-176px -44px}.react-tel-input .gm{background-position:-192px -44px}.react-tel-input .gn{background-position:-208px -44px}.react-tel-input .gp{background-position:-224px -44px}.react-tel-input .gq{background-position:-240px -44px}.react-tel-input .gr{background-position:0 -55px}.react-tel-input .gt{background-position:-16px -55px}.react-tel-input .gu{background-position:-32px -55px}.react-tel-input .gw{background-position:-48px -55px}.react-tel-input .gy{background-position:-64px -55px}.react-tel-input .hk{background-position:-80px -55px}.react-tel-input .hn{background-position:-96px -55px}.react-tel-input .hr{background-position:-112px -55px}.react-tel-input .ht{background-position:-128px -55px}.react-tel-input .hu{background-position:-144px -55px}.react-tel-input .id{background-position:-160px -55px}.react-tel-input .ie{background-position:-176px -55px}.react-tel-input .il{background-position:-192px -55px}.react-tel-input .in{background-position:-208px -55px}.react-tel-input .io{background-position:-224px -55px}.react-tel-input .iq{background-position:-240px -55px}.react-tel-input .ir{background-position:0 -66px}.react-tel-input .is{background-position:-16px -66px}.react-tel-input .it{background-position:-32px -66px}.react-tel-input .je{background-position:-144px -154px}.react-tel-input .jm{background-position:-48px -66px}.react-tel-input .jo{background-position:-64px -66px}.react-tel-input .jp{background-position:-80px -66px}.react-tel-input .ke{background-position:-96px -66px}.react-tel-input .kg{background-position:-112px -66px}.react-tel-input .kh{background-position:-128px -66px}.react-tel-input .ki{background-position:-144px -66px}.react-tel-input .xk{background-position:-128px -154px}.react-tel-input .km{background-position:-160px -66px}.react-tel-input .kn{background-position:-176px -66px}.react-tel-input .kp{background-position:-192px -66px}.react-tel-input .kr{background-position:-208px -66px}.react-tel-input .kw{background-position:-224px -66px}.react-tel-input .ky{background-position:-240px -66px}.react-tel-input .kz{background-position:0 -77px}.react-tel-input .la{background-position:-16px -77px}.react-tel-input .lb{background-position:-32px -77px}.react-tel-input .lc{background-position:-48px -77px}.react-tel-input .li{background-position:-64px -77px}.react-tel-input .lk{background-position:-80px -77px}.react-tel-input .lr{background-position:-96px -77px}.react-tel-input .ls{background-position:-112px -77px}.react-tel-input .lt{background-position:-128px -77px}.react-tel-input .lu{background-position:-144px -77px}.react-tel-input .lv{background-position:-160px -77px}.react-tel-input .ly{background-position:-176px -77px}.react-tel-input .ma{background-position:-192px -77px}.react-tel-input .mc{background-position:-208px -77px}.react-tel-input .md{background-position:-224px -77px}.react-tel-input .me{background-position:-112px -154px;height:12px}.react-tel-input .mg{background-position:0 -88px}.react-tel-input .mh{background-position:-16px -88px}.react-tel-input .mk{background-position:-32px -88px}.react-tel-input .ml{background-position:-48px -88px}.react-tel-input .mm{background-position:-64px -88px}.react-tel-input .mn{background-position:-80px -88px}.react-tel-input .mo{background-position:-96px -88px}.react-tel-input .mp{background-position:-112px -88px}.react-tel-input .mq{background-position:-128px -88px}.react-tel-input .mr{background-position:-144px -88px}.react-tel-input .ms{background-position:-160px -88px}.react-tel-input .mt{background-position:-176px -88px}.react-tel-input .mu{background-position:-192px -88px}.react-tel-input .mv{background-position:-208px -88px}.react-tel-input .mw{background-position:-224px -88px}.react-tel-input .mx{background-position:-240px -88px}.react-tel-input .my{background-position:0 -99px}.react-tel-input .mz{background-position:-16px -99px}.react-tel-input .na{background-position:-32px -99px}.react-tel-input .nc{background-position:-48px -99px}.react-tel-input .ne{background-position:-64px -99px}.react-tel-input .nf{background-position:-80px -99px}.react-tel-input .ng{background-position:-96px -99px}.react-tel-input .ni{background-position:-112px -99px}.react-tel-input .nl,.react-tel-input .bq{background-position:-128px -99px}.react-tel-input .no{background-position:-144px -99px}.react-tel-input .np{background-position:-160px -99px}.react-tel-input .nr{background-position:-176px -99px}.react-tel-input .nu{background-position:-192px -99px}.react-tel-input .nz{background-position:-208px -99px}.react-tel-input .om{background-position:-224px -99px}.react-tel-input .pa{background-position:-240px -99px}.react-tel-input .pe{background-position:0 -110px}.react-tel-input .pf{background-position:-16px -110px}.react-tel-input .pg{background-position:-32px -110px}.react-tel-input .ph{background-position:-48px -110px}.react-tel-input .pk{background-position:-64px -110px}.react-tel-input .pl{background-position:-80px -110px}.react-tel-input .pm{background-position:-96px -110px}.react-tel-input .pr{background-position:-112px -110px}.react-tel-input .ps{background-position:-128px -110px}.react-tel-input .pt{background-position:-144px -110px}.react-tel-input .pw{background-position:-160px -110px}.react-tel-input .py{background-position:-176px -110px}.react-tel-input .qa{background-position:-192px -110px}.react-tel-input .re{background-position:-208px -110px}.react-tel-input .ro{background-position:-224px -110px}.react-tel-input .rs{background-position:-240px -110px}.react-tel-input .ru{background-position:0 -121px}.react-tel-input .rw{background-position:-16px -121px}.react-tel-input .sa{background-position:-32px -121px}.react-tel-input .sb{background-position:-48px -121px}.react-tel-input .sc{background-position:-64px -121px}.react-tel-input .sd{background-position:-80px -121px}.react-tel-input .se{background-position:-96px -121px}.react-tel-input .sg{background-position:-112px -121px}.react-tel-input .sh{background-position:-128px -121px}.react-tel-input .si{background-position:-144px -121px}.react-tel-input .sk{background-position:-160px -121px}.react-tel-input .sl{background-position:-176px -121px}.react-tel-input .sm{background-position:-192px -121px}.react-tel-input .sn{background-position:-208px -121px}.react-tel-input .so{background-position:-224px -121px}.react-tel-input .sr{background-position:-240px -121px}.react-tel-input .ss{background-position:0 -132px}.react-tel-input .st{background-position:-16px -132px}.react-tel-input .sv{background-position:-32px -132px}.react-tel-input .sx{background-position:-48px -132px}.react-tel-input .sy{background-position:-64px -132px}.react-tel-input .sz{background-position:-80px -132px}.react-tel-input .tc{background-position:-96px -132px}.react-tel-input .td{background-position:-112px -132px}.react-tel-input .tg{background-position:-128px -132px}.react-tel-input .th{background-position:-144px -132px}.react-tel-input .tj{background-position:-160px -132px}.react-tel-input .tk{background-position:-176px -132px}.react-tel-input .tl{background-position:-192px -132px}.react-tel-input .tm{background-position:-208px -132px}.react-tel-input .tn{background-position:-224px -132px}.react-tel-input .to{background-position:-240px -132px}.react-tel-input .tr{background-position:0 -143px}.react-tel-input .tt{background-position:-16px -143px}.react-tel-input .tv{background-position:-32px -143px}.react-tel-input .tw{background-position:-48px -143px}.react-tel-input .tz{background-position:-64px -143px}.react-tel-input .ua{background-position:-80px -143px}.react-tel-input .ug{background-position:-96px -143px}.react-tel-input .us{background-position:-112px -143px}.react-tel-input .uy{background-position:-128px -143px}.react-tel-input .uz{background-position:-144px -143px}.react-tel-input .va{background-position:-160px -143px}.react-tel-input .vc{background-position:-176px -143px}.react-tel-input .ve{background-position:-192px -143px}.react-tel-input .vg{background-position:-208px -143px}.react-tel-input .vi{background-position:-224px -143px}.react-tel-input .vn{background-position:-240px -143px}.react-tel-input .vu{background-position:0 -154px}.react-tel-input .wf{background-position:-16px -154px}.react-tel-input .ws{background-position:-32px -154px}.react-tel-input .ye{background-position:-48px -154px}.react-tel-input .za{background-position:-64px -154px}.react-tel-input .zm{background-position:-80px -154px}.react-tel-input .zw{background-position:-96px -154px}.react-tel-input *{-webkit-box-sizing:border-box;box-sizing:border-box;-moz-box-sizing:border-box}.react-tel-input .hide{display:none}.react-tel-input .v-hide{visibility:hidden}.react-tel-input .form-control{position:relative;font-size:.8125rem;letter-spacing:.01rem;margin-top:0!important;margin-bottom:0!important;padding-left:48px;margin-left:0;background:#fff;border:1px solid#cacaca;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;line-height:25px;height:35px;width:300px;outline:none}.react-tel-input .form-control.invalid-number{border:1px solid#d79f9f;background-color:#faf0f0;border-left-color:#cacaca}.react-tel-input .form-control.invalid-number:focus{border:1px solid#d79f9f;border-left-color:#cacaca;background-color:#faf0f0}.react-tel-input .flag-dropdown{position:absolute;top:0;bottom:0;padding:0;background-color:#f5f5f5;border:1px solid#cacaca;-webkit-border-radius:3px 0 0 3px;-moz-border-radius:3px 0 0 3px;border-radius:3px 0 0 3px}.react-tel-input .flag-dropdown:hover,.react-tel-input .flag-dropdown:focus{cursor:pointer}.react-tel-input .flag-dropdown.invalid-number{border-color:#d79f9f}.react-tel-input .flag-dropdown.open{z-index:2;background:#fff;-webkit-border-radius:3px 0 0 0;-moz-border-radius:3px 0 0 0;border-radius:3px 0 0 0}.react-tel-input .flag-dropdown.open .selected-flag{background:#fff;-webkit-border-radius:3px 0 0 0;-moz-border-radius:3px 0 0 0;border-radius:3px 0 0 0}.react-tel-input input[disabled]+.flag-dropdown:hover{cursor:default}.react-tel-input input[disabled]+.flag-dropdown:hover .selected-flag{background-color:transparent}.react-tel-input .selected-flag{outline:none;position:relative;width:38px;height:100%;padding:0 0 0 8px;-webkit-border-radius:3px 0 0 3px;-moz-border-radius:3px 0 0 3px;border-radius:3px 0 0 3px}.react-tel-input .selected-flag:hover,.react-tel-input .selected-flag:focus{background-color:#fff}.react-tel-input .selected-flag .flag{position:absolute;top:50%;margin-top:-5px}.react-tel-input .selected-flag .arrow{position:relative;top:50%;margin-top:-2px;left:20px;width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid#555}.react-tel-input .selected-flag .arrow.up{border-top:none;border-bottom:4px solid#555}.react-tel-input .country-list{outline:none;z-index:1;list-style:none;position:absolute;padding:0;margin:10px 0 10px -1px;-webkit-box-shadow:1px 2px 10px rgba(0,0,0,.35);-moz-box-shadow:1px 2px 10px rgba(0,0,0,.35);box-shadow:1px 2px 10px rgba(0,0,0,.35);background-color:white;width:300px;max-height:200px;overflow-y:scroll;-webkit-border-radius:0 0 3px 3px;-moz-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px}.react-tel-input .country-list .flag{display:inline-block}.react-tel-input .country-list .divider{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid#ccc}.react-tel-input .country-list .country{padding:7px 9px}.react-tel-input .country-list .country .dial-code{color:#6b6b6b}.react-tel-input .country-list .country:hover{background-color:#f1f1f1}.react-tel-input .country-list .country.highlight{background-color:#f1f1f1}.react-tel-input .country-list .flag{margin-right:7px;margin-top:2px}.react-tel-input .country-list .country-name{margin-right:6px}.react-tel-input .country-list .search{position:-webkit-sticky;position:sticky;top:0;background-color:#fff;padding:10px 0 6px 10px}.react-tel-input .country-list .search-emoji{font-size:.844rem}.react-tel-input .country-list .search-box{border:1px solid#cacaca;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;font-size:.844rem;line-height:15px;margin-left:6px;padding:3px 8px 5px;outline:none}.react-tel-input .country-list .no-entries-message{padding:7px 10px 11px;opacity:.7}.react-tel-input .invalid-number-message{position:absolute;z-index:1;font-size:.731rem;left:46px;top:-8px;background:#fff;padding:0 2px;color:#de0000}');
phoneInputStyles.__hash = "ff69f46855722c1d";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input.js












var PhoneInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PhoneInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PhoneInput);
    function PhoneInput(props) {
        (0,_class_call_check/* default */.Z)(this, PhoneInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(PhoneInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, value = _props.value, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, id = _props.id;
                var inputName = inputData.inputName, isRequired = inputData.isRequired;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var defaultCountry = cloudfrontViewerCountry && cloudfrontViewerCountry.toLowerCase() || "us";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: id,
                    className: "jsx-".concat(phone_input_scss_componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash, " jsx-").concat(phoneInputStyles.__hash) + " " + "hp-input hp-phone-input",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                            country: defaultCountry,
                            value: value,
                            onChange: function(phone) {
                                return onInputChange({
                                    target: {
                                        name: inputName,
                                        value: phone
                                    }
                                });
                            },
                            onBlur: function() {
                                return onInputBlur({
                                    target: {
                                        name: inputName,
                                        value: value
                                    }
                                });
                            },
                            name: inputName,
                            enableSearch: true,
                            disableSearchIcon: true,
                            inputClass: showRequiredError ? "input-required" : "",
                            specialLabel: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: phoneInputStyles.__hash,
                            children: phoneInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: phone_input_scss_componentStyles.__hash,
                            children: phone_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return PhoneInput;
}(react.PureComponent);
PhoneInput.defaultProps = {};
/* harmony default export */ var phone_input = ((0,generic_config_context/* withGenericConfig */.P)(PhoneInput));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/select-input/select-input.scss.js
var select_input_scss_componentStyles = new String(".hp-select-input{font-size:.8125rem;&.is-placholder{color:gray}}");
select_input_scss_componentStyles.__hash = "9272064ecffd449c";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/select-input/select-input.js





function select_input_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var SelectInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SelectInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SelectInput);
    function SelectInput(props) {
        (0,_class_call_check/* default */.Z)(this, SelectInput);
        var _this;
        _this = _super.call(this, props);
        select_input_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderOptions", function(options, defaultValue) {
            var translate = _this.props.translate;
            var optionsToRender = options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    className: "contact-form-row",
                    value: option,
                    name: option,
                    children: translate(option)
                }, option);
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    defaultValue && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        disabled: true,
                        value: defaultValue,
                        children: translate(defaultValue)
                    }),
                    optionsToRender
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SelectInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, value = _props.value, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id;
                var inputName = inputData.inputName, isRequired = inputData.isRequired, options = inputData.options, defaultValue = inputData.defaultValue;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            value: value || defaultValue,
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            className: "jsx-".concat(select_input_scss_componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-select-input", requiredClass, {
                                "is-placholder": !value
                            }) || ""),
                            children: this.renderOptions(options, defaultValue)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: select_input_scss_componentStyles.__hash,
                            children: select_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return SelectInput;
}(react.PureComponent);
SelectInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var select_input = ((0,generic_config_context/* withGenericConfig */.P)(SelectInput));

;// CONCATENATED MODULE: ./client/components/system/form-inputs/checkbox-input/checkbox-input.scss.js
var checkbox_input_scss_componentStyles = new String(".consent-checkbox{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;text-align:left;.checkbox{margin-right:8px}}");
checkbox_input_scss_componentStyles.__hash = "238ebeb04f37ba2c";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/checkbox-input/checkbox-input.js










var CheckboxInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CheckboxInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CheckboxInput);
    function CheckboxInput(props) {
        (0,_class_call_check/* default */.Z)(this, CheckboxInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(CheckboxInput, [
        {
            key: "isChecked",
            value: function isChecked() {
                var _this__input;
                return (_this__input = this._input) === null || _this__input === void 0 ? void 0 : _this__input.checked;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, inputData = _props.inputData, id = _props.id, defaultValue = _props.defaultValue, onInputChange = _props.onInputChange, translate = _props.translate;
                var inputName = inputData.inputName, text = inputData.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: id,
                    className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + "consent-checkbox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + (classnames_default()("input-title") || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    defaultChecked: defaultValue,
                                    name: inputName,
                                    onChange: function() {
                                        return onInputChange({
                                            target: {
                                                name: inputName,
                                                value: _this.isChecked()
                                            }
                                        });
                                    },
                                    ref: function(input) {
                                        return _this._input = input;
                                    },
                                    className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + "checkbox"
                                }),
                                translate(text)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: checkbox_input_scss_componentStyles.__hash,
                            children: checkbox_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return CheckboxInput;
}(react.PureComponent);
/* harmony default export */ var checkbox_input = ((0,generic_config_context/* withGenericConfig */.P)(CheckboxInput));

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 13 modules
var react_select_browser_esm = __webpack_require__(16455);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-input.scss.js


// We put here styles that we can't manipulate straight from the react-select component styles prop (see react-select-styles.js)
var multi_select_input_scss_componentStyles = new String(".hp-multi-select-input{.action-indicator{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;stroke:rgba(0,0,0,.7);&:hover{stroke:rgba(0,0,0,1)}}.multi-select-custom-option{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.custom-checkbox{margin-right:10px;width:18px;height:18px;background-color:white;border:1px solid#cbcbcb;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;&.selected{background-color:".concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border:none}}}&.is-single{min-width:156px;.react-select__menu .custom-checkbox{display:none}.react-select__option--is-selected{background-color:").concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";color:").concat(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], "}}}"));
multi_select_input_scss_componentStyles.__hash = "6ec193b2540e5c88";

// EXTERNAL MODULE: ./node_modules/react-select/dist/index-75b02bac.browser.esm.js + 1 modules
var index_75b02bac_browser_esm = __webpack_require__(97896);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/close-icon.js

function CloseIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1L9 9",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 1L1 9",
                strokeWidth: "1.5"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/dropdown-icon.js

function DropdownIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1L5 5L9 1",
            strokeWidth: "1.5"
        })
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/checkmark-icon.js

function CheckmarkIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "10",
        viewBox: "0 0 13 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.5 3.91667L5.48565 8L12.3182 1",
            stroke: "white",
            "stroke-width": "1.5"
        })
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-custom-components.js
function multi_select_custom_components_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_select_custom_components_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






// Custom Option component with custom checkbox
var Option = function(props) {
    var isSelected = props.isSelected, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_75b02bac_browser_esm.F.Option, _object_spread_props(_object_spread({}, props), {
            className: "multi-select-custom-option",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("custom-checkbox", {
                        selected: isSelected
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: label
                })
            ]
        }))
    });
};
var MultiValueRemove = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_75b02bac_browser_esm.F.MultiValueRemove, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
    }));
};
// taken from the docs: https://react-select.com/components search for "ClearIndicator"
var ClearIndicator = function(props) {
    var _children = props.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}) : _children, getStyles = props.getStyles, ref = props.innerProps.ref, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action-indicator",
            children: children
        })
    }));
};
// same as ClearIndicator
var DropdownIndicator = function(props) {
    var _children = props.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownIcon, {}) : _children, getStyles = props.getStyles, ref = props.innerProps.ref, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action-indicator",
            children: children
        })
    }));
};

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-styles.js
function multi_select_styles_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_select_styles_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_select_styles_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multi_select_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multi_select_styles_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multi_select_styles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


// docs: https://react-select.com/styles#the-styles-prop
function getReactSelectStyles(invalid) {
    var selectStyles = {
        control: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                minHeight: "40px",
                borderColor: "".concat(invalid ? colors/* default.red */.Z.red : colors/* default.wolf */.Z.wolf)
            });
        },
        menu: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                padding: "8px"
            });
        },
        option: function(styles, state) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                textAlign: "left",
                padding: "10px 8px 10px 8px",
                color: "black",
                backgroundColor: state.isFocused ? colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME] : "transparent"
            });
        },
        multiValue: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                backgroundColor: "#DED4FC",
                height: "30px",
                borderRadius: "20px",
                padding: "4px 10px 4px 10px"
            });
        },
        multiValueLabel: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                fontSize: "12px",
                display: "flex",
                alignItems: "center"
            });
        },
        multiValueRemove: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                height: "100%",
                borderRadius: "20px",
                stroke: "rgba(0, 0, 0, 0.7)",
                "&:hover": {
                    stroke: "rgba(0, 0, 0, 1)",
                    backgroundColor: "transparent"
                }
            });
        },
        indicatorsContainer: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                paddingLeft: "0px"
            });
        },
        indicatorSeparator: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                visibility: "hidden",
                width: "0px"
            });
        }
    };
    return selectStyles;
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-input.js









// react-select docs: https://react-select.com/home
function MultiSelectInput(props) {
    var inputData = props.inputData, onInputChange = props.onInputChange, onInputBlur = props.onInputBlur, value = props.value, invalid = props.invalid, errorLabelId = props.errorLabelId, id = props.id, translate = props.translate;
    var inputName = inputData.inputName, isRequired = inputData.isRequired, options = inputData.options, defaultValue = inputData.defaultValue, isMulti = inputData.isMulti, placeholder = inputData.placeholder, closeMenuOnSelect = inputData.closeMenuOnSelect;
    var getTranslatedOptions = function() {
        return options.map(function(option) {
            return {
                label: translate(option.label),
                value: option.value
            };
        });
    };
    var getTranslatedPlaceholder = function() {
        return translate(placeholder);
    };
    var onBlur = function() {
        // we change the data from react-select to be the same as the data from the other inputs
        onInputBlur({
            target: {
                name: inputName,
                value: value !== null && value !== void 0 ? value : ""
            }
        });
    };
    var onChange = function(newValue, action) {
        // we change the data from react-select to be the same as the data from the other inputs
        onInputChange({
            target: {
                name: action.name,
                value: newValue
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                className: classnames_default()("hp-multi-select-input", {
                    "is-single": !isMulti
                }),
                classNamePrefix: "react-select",
                id: id,
                name: inputName,
                onChange: onChange,
                onBlur: onBlur,
                defaultValue: defaultValue,
                options: getTranslatedOptions(),
                placeholder: getTranslatedPlaceholder(),
                components: {
                    Option: Option,
                    MultiValueRemove: MultiValueRemove,
                    ClearIndicator: ClearIndicator,
                    DropdownIndicator: DropdownIndicator
                },
                isMulti: isMulti,
                hideSelectedOptions: false,
                styles: getReactSelectStyles(invalid),
                required: isRequired,
                "aria-required": isRequired,
                "aria-invalid": invalid,
                "aria-describedby": errorLabelId,
                isSearchable: false,
                closeMenuOnSelect: closeMenuOnSelect || false,
                blurInputOnSelect: false,
                value: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: multi_select_input_scss_componentStyles.__hash,
                children: multi_select_input_scss_componentStyles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            })
        ]
    });
}
/* harmony default export */ var multi_select_input = ((0,generic_config_context/* withGenericConfig */.P)(MultiSelectInput));

;// CONCATENATED MODULE: ./client/services/form-service/form-inputs.js









var inputTypes = {
    TEXT: "text",
    NUMBER: "number",
    EMAIL: "email",
    SELECT: "select",
    TEXT_AREA: "text_area",
    PHONE: "phone",
    CHECKBOX: "checkbox",
    MULTI_SELECT: "multi_select"
};
var _obj;
var inputTypesToComponent = (_obj = {}, (0,_define_property/* default */.Z)(_obj, inputTypes.TEXT, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.NUMBER, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.EMAIL, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.SELECT, select_input), (0,_define_property/* default */.Z)(_obj, inputTypes.MULTI_SELECT, multi_select_input), (0,_define_property/* default */.Z)(_obj, inputTypes.TEXT_AREA, textarea_input), (0,_define_property/* default */.Z)(_obj, inputTypes.PHONE, phone_input), (0,_define_property/* default */.Z)(_obj, inputTypes.CHECKBOX, checkbox_input), _obj);
var MAXIMUM_INPUT_LENGTH = 40;
var MINIMUM_PHONE_LENGTH = 8;
var MAXIMUM_PHONE_LENGTH = 40;
var MAXIMUM_LONG_INPUT_LENGTH = 120;
var getInputComponentByType = function(type) {
    return inputTypesToComponent[type] || text_input;
};
var FIRSTNAME_INPUT = {
    id: "first_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.firstName",
    validate: function(val) {
        return val.length < MAXIMUM_INPUT_LENGTH;
    }
};
var LASTNAME_INPUT = {
    id: "last_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.lastName",
    validate: function(val) {
        return val.length < MAXIMUM_INPUT_LENGTH;
    }
};
var EMAIL_INPUT = {
    id: "email",
    type: inputTypes.EMAIL,
    title: "forms.fieldTitle.workEmail",
    placeholder: "name@company.com",
    validate: function(val) {
        return input_validations_patterns/* EMAIL_PATTERN.test */.Q.test(val);
    },
    errorMessage: "forms.emailField.errorMessage"
};
var PHONE_INPUT = {
    id: "phone",
    type: inputTypes.PHONE,
    title: "forms.fieldTitle.phoneNumber",
    validate: function(val) {
        return (val === null || val === void 0 ? void 0 : val.length) >= MINIMUM_PHONE_LENGTH && (val === null || val === void 0 ? void 0 : val.length) < MAXIMUM_PHONE_LENGTH;
    },
    errorMessage: "forms.phoneField.errorMessage"
};
var COMPANY_SIZE_INPUT = {
    id: "company_size",
    type: inputTypes.SELECT,
    title: "forms.fieldTitle.companySize",
    options: form_constants/* companySizeList */.N7,
    defaultValue: "forms.fields.selectPlaceholder"
};
var CHECKBOX_INPUT = {
    id: "checkbox_input",
    type: inputTypes.CHECKBOX,
    text: "forms.zendesk.tickets.contactConsentCheckbox",
    defaultValue: false
};


/***/ }),

/***/ 49228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PD": function() { return /* binding */ CONTACT_SALES_HUBSPOT_FORM_ID; },
  "Qo": function() { return /* binding */ EMAIL_ONLY_FORM_ID; },
  "yF": function() { return /* binding */ EVENTS_HUBSPOT_FORM_ID; },
  "f": function() { return /* binding */ NURTURE_CONTACT_US_FORM_ID; },
  "Im": function() { return /* binding */ PORTAL_ID; },
  "F0": function() { return /* binding */ REPORT_FORM_ID; },
  "pO": function() { return /* binding */ REQUEST_A_DEMO_HUBSPOT_FORM_ID; },
  "aC": function() { return /* binding */ TEST_CONTACT_SALES_HUBSPOT_FORM_ID; },
  "ND": function() { return /* binding */ TEST_PORTAL_ID; },
  "Ty": function() { return /* binding */ getContactFormConfigById; }
});

// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/services/form-service/form-inputs.js + 18 modules
var form_inputs = __webpack_require__(5893);
// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
;// CONCATENATED MODULE: ./client/services/hubspot-service/hubspot-inputs.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var validateHowCanWeHelpFieldRequiredByCompanySize = function(currentValue, allInputsValues) {
    var _allInputsValues_HUBSPOT_API_COMPANY_SIZE;
    var companySize = (_allInputsValues_HUBSPOT_API_COMPANY_SIZE = allInputsValues[hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4]) === null || _allInputsValues_HUBSPOT_API_COMPANY_SIZE === void 0 ? void 0 : _allInputsValues_HUBSPOT_API_COMPANY_SIZE.value;
    if (companySize === form_constants/* SMALLEST_COMPANY_SIZE */.oP) {
        return !!currentValue; //this can't be empty because CS need this value
    }
    return true;
};
var getEmail = function() {
    var emailParam = (0,url.getUrlParamValueFromCurrentLocation)("email");
    var emailString = emailParam.replace("%40", "@").replace(" ", "+");
    return emailString;
};
var HUBSPOT_FIRSTNAME_INPUT = _object_spread_props(_object_spread({}, form_inputs/* FIRSTNAME_INPUT */.oo), {
    inputName: hubspot_constants/* HUBSPOT_API_FIRSTNAME */.uy,
    isRequired: true
});
var HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* FIRSTNAME_INPUT */.oo), {
    inputName: hubspot_constants/* HUBSPOT_API_FIRSTNAME */.uy,
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredFirstName"
});
var HUBSPOT_LASTNAME_INPUT = _object_spread_props(_object_spread({}, form_inputs/* LASTNAME_INPUT */.Ce), {
    inputName: hubspot_constants/* HUBSPOT_API_LASTNAME */.aH,
    isRequired: true
});
var HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* LASTNAME_INPUT */.Ce), {
    inputName: hubspot_constants/* HUBSPOT_API_LASTNAME */.aH,
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredLastName"
});
var HUBSPOT_EMAIL_INPUT = _object_spread_props(_object_spread({}, form_inputs/* EMAIL_INPUT */.I6), {
    inputName: hubspot_constants/* HUBSPOT_API_EMAIL */.dP,
    defaultValue: getEmail(),
    isRequired: true
});
var HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* EMAIL_INPUT */.I6), {
    inputName: hubspot_constants/* HUBSPOT_API_EMAIL */.dP,
    defaultValue: getEmail(),
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredWorkEmail"
});
var HUBSPOT_JOBTITLE_INPUT = {
    id: "job_title",
    inputName: hubspot_constants/* HUBSPOT_API_JOB */.W_,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: false,
    title: "contactSales.hubspotForm.form.fieldTitle.jobTitle",
    validate: function(val) {
        return !val || val.length < form_inputs/* MAXIMUM_LONG_INPUT_LENGTH */.wY;
    },
    errorMessage: "contactSales.hubspotForm.form.fieldErrorMsg.jobTitle"
};
var HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER = {
    id: "job_title",
    inputName: hubspot_constants/* HUBSPOT_API_JOB */.W_,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: false,
    title: "contactSales.hubspotForm.form.fieldTitle.jobTitle",
    validate: function(val) {
        return !val || val.length < form_inputs/* MAXIMUM_LONG_INPUT_LENGTH */.wY;
    },
    errorMessage: "contactSales.hubspotForm.form.fieldErrorMsg.jobTitle",
    placeholder: "contactSales.hubspotForm.form.fieldTitle.jobTitle"
};
var HUBSPOT_PHONE_INPUT = _object_spread_props(_object_spread({}, form_inputs/* PHONE_INPUT */.l5), {
    inputName: hubspot_constants/* HUBSPOT_API_PHONE */.dG,
    isRequired: true
});
var HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER = {
    id: "company_name",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY */.$G,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: true,
    placeholder: "contactSales.hubspotForm.form.fieldTitle.requiredCompanyName"
};
var HUBSPOT_COMPANY_INPUT = {
    id: "company_name",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY */.$G,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: true,
    title: "contactSales.hubspotForm.form.fieldTitle.companyName"
};
var HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER = {
    id: "company_size",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: false,
    options: form_constants/* companySizeValuesList */.Dp,
    placeholder: "forms.fieldTitle.RequiredCompanySize",
    isRequired: true,
    closeMenuOnSelect: true
};
var HUBSPOT_COMPANYSIZE_INPUT = {
    id: "company_size",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: false,
    options: form_constants/* companySizeValuesList */.Dp,
    title: "forms.fieldTitle.companySize",
    isRequired: true,
    closeMenuOnSelect: true
};
var getHubspotHowCanHelpInput = function() {
    var overrideParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        id: "how_can_help",
        inputName: hubspot_constants/* HUBSPOT_API_HOW_CAN_HELP */.db,
        type: form_inputs/* inputTypes.TEXT_AREA */.Je.TEXT_AREA,
        isRequired: false,
        placeholder: (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.placeholderKey) || "contactSales.hubspotForm.form.fieldPlaceholder.howCanHelp",
        title: (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.titleKey) || "contactSales.hubspotForm.form.fieldTitle.howCanHelp",
        validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
        errorMessage: "forms.detailsField.requiredSoWeCanHelpError"
    };
};
var HUBSPOT_HOWPLANUSE_INPUT = {
    id: "how_plan_use",
    inputName: hubspot_constants/* HUBSPOT_API_HOW_CAN_HELP */.db,
    type: form_inputs/* inputTypes.TEXT_AREA */.Je.TEXT_AREA,
    isRequired: false,
    placeholder: "contactSales.hubspotForm.form.fieldPlaceholder.howCanHelp",
    title: "contactSales.hubspotForm.form.fieldTitle.howPlanToUse",
    validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
    errorMessage: "forms.detailsField.requiredSoWeCanHelpError"
};
var HUBSPOT_PRODUCT_QUESTION_INPUT = {
    id: "product_question",
    inputName: hubspot_constants/* HUBSPOT_API_PRODUCT_QUESTION */.eo,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: true,
    title: "contactSales.hubspotForm.form.fieldTitle.productQuestion",
    options: hubspot_constants/* productQuestionOptionsList */.Ys,
    placeholder: "forms.fields.selectPlaceholder",
    isRequired: true,
    errorMessage: "forms.requiredError"
};
var HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER = {
    id: "product_question",
    inputName: hubspot_constants/* HUBSPOT_API_PRODUCT_QUESTION */.eo,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: true,
    options: hubspot_constants/* productQuestionOptionsList */.Ys,
    placeholder: "contactSales.hubspotForm.form.fieldTitle.shorterRequiredProductQuestion",
    isRequired: true,
    errorMessage: "forms.requiredError"
};

;// CONCATENATED MODULE: ./client/services/hubspot-service/contact-form-config.js
function contact_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function contact_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            contact_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function contact_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function contact_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        contact_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var PORTAL_ID = "5945317";
var TEST_PORTAL_ID = "22796107";
var CONTACT_SALES_HUBSPOT_FORM_ID = "215c1dc9-0c3c-44ad-be61-add5f71dfe22";
var REQUEST_A_DEMO_HUBSPOT_FORM_ID = "1027e76f-6a94-489b-8ee3-e6d8141cc0f6";
var REPORT_FORM_ID = "1091544b-bff2-40ef-aada-8acfea9089b3";
var NURTURE_CONTACT_US_FORM_ID = "38593c14-af5b-4f56-8d3b-a403dee4266b";
var EMAIL_ONLY_FORM_ID = "c46e9209-b721-472f-8c2e-b151cba6d12e";
var EVENTS_HUBSPOT_FORM_ID = "192ded92-8c95-44bd-bf4e-1fcf0a32c0c2";
// used for testing only
var TEST_CONTACT_SALES_HUBSPOT_FORM_ID = "6fe93320-3033-4c28-9215-c19b535ebcae";
var getOverrideParamsForCampaigin = function(campaignId) {
    if (campaignId === campaigns/* IPO_CAMPAIGN_ID */.Q) {
        return {
            titleKey: "contactSales.hubspotForm.form.ipoCampaignFieldTitle.howCanHelp",
            placeholderKey: "contactSales.hubspotForm.form.ipoCampaignFieldPlaceholder.howCanHelp"
        };
    }
    return null;
};
var getContactSalesConfig = function(param) {
    var formId = param.formId, campaignId = param.campaignId, withSubmitNotice = param.withSubmitNotice, formTitle = param.formTitle, lastNameFirst = param.lastNameFirst, isV2 = param.isV2, firstFormSubmitted = param.firstFormSubmitted;
    var overrideParams = getOverrideParamsForCampaigin(campaignId);
    var getFirstNameLastNameRow = function() {
        var withPlaceHolder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var row = withPlaceHolder ? [
            HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER,
            HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER
        ] : [
            HUBSPOT_FIRSTNAME_INPUT,
            HUBSPOT_LASTNAME_INPUT
        ];
        return lastNameFirst ? row.reverse() : row;
    };
    var getProductQuestionRow = function() {
        var withPlaceHolder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (withPlaceHolder) {
            return HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER;
        }
        return HUBSPOT_PRODUCT_QUESTION_INPUT;
    };
    var getMainFormConfig = function() {
        if (isV2) {
            return {
                formTitle: formTitle,
                rows: [
                    getFirstNameLastNameRow(true),
                    [
                        HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER
                    ],
                    [
                        HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER,
                        HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER
                    ],
                    [
                        getProductQuestionRow(true)
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: withSubmitNotice ? "contactSales.hubspotForm.form.submitButton" : "contactSales.hubspotForm.form.contactUsButton"
            };
        }
        return {
            formTitle: formTitle,
            rows: [
                getFirstNameLastNameRow(),
                [
                    HUBSPOT_EMAIL_INPUT,
                    HUBSPOT_JOBTITLE_INPUT
                ],
                [
                    HUBSPOT_PHONE_INPUT
                ],
                [
                    HUBSPOT_COMPANY_INPUT,
                    HUBSPOT_COMPANYSIZE_INPUT
                ],
                [
                    getProductQuestionRow()
                ],
                [
                    getHubspotHowCanHelpInput(overrideParams)
                ]
            ],
            submitButtonText: withSubmitNotice ? "contactSales.hubspotForm.form.submitButton" : "contactSales.hubspotForm.form.contactUsButton"
        };
    };
    switch(formId){
        case CONTACT_SALES_HUBSPOT_FORM_ID:
        case TEST_CONTACT_SALES_HUBSPOT_FORM_ID:
            return getMainFormConfig();
        case REQUEST_A_DEMO_HUBSPOT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        HUBSPOT_HOWPLANUSE_INPUT
                    ]
                ]
            };
        case REPORT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getReport"
            };
        case NURTURE_CONTACT_US_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getInTouch",
                privacyNoticeText: "forms.getInTouch.privacyNotice"
            };
        case EMAIL_ONLY_FORM_ID:
            return {
                rows: [
                    [
                        HUBSPOT_EMAIL_INPUT
                    ]
                ],
                submitButtonText: "Submit"
            };
        case EVENTS_HUBSPOT_FORM_ID:
            return {
                formTitle: formTitle,
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.register"
            };
        default:
            return {
                rows: []
            };
    }
};
var getContactFormConfigById = function(param) {
    var formId = param.formId, _overrideCampaignId = param.overrideCampaignId, overrideCampaignId = _overrideCampaignId === void 0 ? null : _overrideCampaignId, _withSubmitNotice = param.withSubmitNotice, withSubmitNotice = _withSubmitNotice === void 0 ? true : _withSubmitNotice, formTitle = param.formTitle, lastNameFirst = param.lastNameFirst, isV2 = param.isV2, firstFormSubmitted = param.firstFormSubmitted, privacyNoticeText = param.privacyNoticeText, _ctaProps = param.ctaProps, ctaProps = _ctaProps === void 0 ? {} : _ctaProps;
    var formData = getContactSalesConfig({
        formId: formId,
        overrideCampaignId: overrideCampaignId,
        withSubmitNotice: withSubmitNotice,
        formTitle: formTitle,
        lastNameFirst: lastNameFirst,
        isV2: isV2,
        firstFormSubmitted: firstFormSubmitted
    });
    return contact_form_config_object_spread_props(contact_form_config_object_spread({}, formData), {
        ctaProps: ctaProps,
        privacyNoticeText: privacyNoticeText || formData.privacyNoticeText
    });
};


/***/ }),

/***/ 22638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ HUBSPOT_API_COMPANY; },
/* harmony export */   "$K": function() { return /* binding */ HUBSPOT_API_VISITOR; },
/* harmony export */   "AB": function() { return /* binding */ NUMBER_OF_SEATS_PARAM; },
/* harmony export */   "AX": function() { return /* binding */ HUBSPOT_ELIGIBLE_FOR_BAM; },
/* harmony export */   "Cf": function() { return /* binding */ RECENT_CONVERSION_URL_QUERY_PARAM; },
/* harmony export */   "L_": function() { return /* binding */ leadSourceConfigList; },
/* harmony export */   "Mj": function() { return /* binding */ HUBSPOT_API_CLUSTER; },
/* harmony export */   "Oe": function() { return /* binding */ HUBSPOT_API_UTM_SOURCE; },
/* harmony export */   "TO": function() { return /* binding */ PII_PARAMS; },
/* harmony export */   "Ts": function() { return /* binding */ leadSourceDefaultValue; },
/* harmony export */   "W_": function() { return /* binding */ HUBSPOT_API_JOB; },
/* harmony export */   "Wm": function() { return /* binding */ HUBSPOT_CONTACT_SALES_CTA; },
/* harmony export */   "Yk": function() { return /* binding */ HUBSPOT_API_UTM_CONTENT; },
/* harmony export */   "Ys": function() { return /* binding */ productQuestionOptionsList; },
/* harmony export */   "_g": function() { return /* binding */ HUBSPOT_API_PRIVACY_CONSENT; },
/* harmony export */   "aH": function() { return /* binding */ HUBSPOT_API_LASTNAME; },
/* harmony export */   "bn": function() { return /* binding */ HUBSPOT_API_UTM_TERM; },
/* harmony export */   "cj": function() { return /* binding */ HUBSPOT_API_FROM; },
/* harmony export */   "dG": function() { return /* binding */ HUBSPOT_API_PHONE; },
/* harmony export */   "dP": function() { return /* binding */ HUBSPOT_API_EMAIL; },
/* harmony export */   "db": function() { return /* binding */ HUBSPOT_API_HOW_CAN_HELP; },
/* harmony export */   "eo": function() { return /* binding */ HUBSPOT_API_PRODUCT_QUESTION; },
/* harmony export */   "fD": function() { return /* binding */ CUSTOM_EVENTS; },
/* harmony export */   "gu": function() { return /* binding */ AI_ANALYZER_VALUES; },
/* harmony export */   "h4": function() { return /* binding */ HUBSPOT_API_COMPANY_SIZE; },
/* harmony export */   "lF": function() { return /* binding */ HUBSPOT_API_PRICING_VERSION; },
/* harmony export */   "lG": function() { return /* binding */ HUBSPOT_CONTACT_SALES_AI_ANALYZER_FIELD_NAME; },
/* harmony export */   "nZ": function() { return /* binding */ HUBSPOT_API_UTM_CAMPAIGN; },
/* harmony export */   "rX": function() { return /* binding */ HUBSPOT_API_SOURCE; },
/* harmony export */   "s": function() { return /* binding */ HUBSPOT_API_UTM_MEDIUM; },
/* harmony export */   "sD": function() { return /* binding */ SALES_ENRICHMENT_PARAM_TYPES; },
/* harmony export */   "sy": function() { return /* binding */ URL_PARAM_FROM; },
/* harmony export */   "tT": function() { return /* binding */ HUBSPOT_API_RECENT_CONVERSION_URL; },
/* harmony export */   "ti": function() { return /* binding */ AI_CONTACT_SALES_ANALYZER_RESPONSE_TO_HUBSPOT_FIELD_MAP; },
/* harmony export */   "uy": function() { return /* binding */ HUBSPOT_API_FIRSTNAME; },
/* harmony export */   "xT": function() { return /* binding */ HUBSPOT_API_AB_TEST_NAME; },
/* harmony export */   "y8": function() { return /* binding */ HUBSPOT_CONTACT_SALES_CTA_TRANSLATED; },
/* harmony export */   "yM": function() { return /* binding */ HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE; },
/* harmony export */   "zj": function() { return /* binding */ SALES_ENRICHMENT_PARAM_LIST; }
/* harmony export */ });
/* unused harmony export HUBSPOT_API_UTM_BANNER */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var leadSourceDefaultValue = "Website - Contact Sales";
var leadSourceConfigList = [
    {
        value: "Website - Contact Sales",
        text: "Website - Contact Sales"
    },
    {
        value: "Landing Page - Contact Sales",
        text: "Landing Page - Contact Sales"
    },
    {
        value: "Website - Request a Demo",
        text: "Website - Request a Demo"
    },
    {
        value: "Linkedin - Contact Sales",
        text: "Linkedin - Contact Sales"
    },
    {
        value: "Linkedin - Request a Demo",
        text: "Linkedin - Request a Demo"
    },
    {
        value: "Content",
        text: "Content"
    },
    {
        value: "Contact Sales - Tech Partner",
        text: "Contact Sales - Tech Partner"
    },
    {
        value: "Webinar",
        text: "Webinar"
    },
    {
        value: "Mobile - Contact Sales",
        text: "Mobile - Contact Sales"
    },
    {
        value: "Xing",
        text: "Xing"
    },
    {
        value: "Website - Nurture Contact Sales",
        text: "Website - Nurture Contact Sales"
    },
    {
        value: "Event",
        text: "Event"
    }
];
var CUSTOM_EVENTS = {
    FORM_SUBMISSION: "pe5945317_website_contact_sales_form_submission",
    ELIGIBLE_FOR_WEBSITE_BOT: "pe5945317_eligible_for_website_bot",
    BAM_CALENDAR_REACHED: "pe5945317_website_bam_calendar"
};
var HUBSPOT_API_FIRSTNAME = "firstname";
var HUBSPOT_API_LASTNAME = "lastname";
var HUBSPOT_API_EMAIL = "email";
var HUBSPOT_API_JOB = "jobtitle";
var HUBSPOT_API_PHONE = "phone";
var HUBSPOT_API_COMPANY = "company";
var HUBSPOT_API_COMPANY_SIZE = "company_size__c";
var HUBSPOT_API_PRODUCT_QUESTION = "product_question_hs_forms";
var HUBSPOT_API_HOW_CAN_HELP = "how_can_our_consulting_team_help_you";
var HUBSPOT_CONTACT_SALES_AI_ANALYZER_FIELD_NAME = "contact_sales_ai_analyzer";
var HUBSPOT_API_CLUSTER = "cluster_hs";
var HUBSPOT_API_VISITOR = "visitor_id";
var HUBSPOT_API_SOURCE = "leadsource";
var HUBSPOT_API_FROM = "from";
var HUBSPOT_API_PRIVACY_CONSENT = "seen_legal_disclaimer";
var HUBSPOT_API_PRICING_VERSION = "website_pricing_version";
var HUBSPOT_API_RECENT_CONVERSION_URL = "recent_conversion_url";
var HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE = "recent_conversion_referrer_page";
var HUBSPOT_API_AB_TEST_NAME = "web_presence_test_name";
var HUBSPOT_API_UTM_SOURCE = "utm_source";
var HUBSPOT_API_UTM_CAMPAIGN = "utm_campaign";
var HUBSPOT_API_UTM_TERM = "utm_term";
var HUBSPOT_API_UTM_BANNER = "utm_banner";
var HUBSPOT_API_UTM_CONTENT = "utm_content";
var HUBSPOT_API_UTM_MEDIUM = "utm_medium";
var HUBSPOT_ELIGIBLE_FOR_BAM = "eligible_for_book_a_meeting";
var HUBSPOT_CONTACT_SALES_CTA = "contact_sales_cta";
var HUBSPOT_CONTACT_SALES_CTA_TRANSLATED = "contact_sales_cta_translated";
var HUBSPOT_API_UTM_ADGROUP = "utm_adgroup";
var HUBSPOT_API_UTM_KEYWORD = "utm_keyword";
var HUBSPOT_API_NUMBER_OF_SEATS = "number_of_seats_last_selected_pricing_page";
var URL_PARAM_FROM = "from";
var PII_PARAMS = [
    HUBSPOT_API_FIRSTNAME,
    HUBSPOT_API_LASTNAME,
    HUBSPOT_API_EMAIL,
    HUBSPOT_API_PHONE
];
/* this is {label: String, value: String} objects list to fit the react-select input,
changing the values will break the form (in hubspot) */ var productQuestionOptionsList = [
    {
        label: "contactSales.hubspotForm.form.productQuestion.workManagement",
        value: "Work & project management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.crm",
        value: "Sales & CRM"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.product",
        value: "Product management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.softwareDevelopment",
        value: "Software development"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.service",
        value: "Ticketing & service management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.other",
        value: "Other"
    }
];
// The UTM consts are used as both url param names and keys in the local storage
var UTM_SOURCE = "utm_source";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_BANNER = "utm_banner";
var UTM_CONTENT = "utm_content";
var UTM_ADGROUP = "utm_adgroup";
var UTM_MEDIUM = "utm_medium";
var UTM_KEYWORD = "utm_keyword";
var NUMBER_OF_SEATS_PARAM = "number_of_seats_last_selected_pricing_page";
var AI_ANALYZER_VALUES = {
    SALES: "sales",
    SALES_SMALL: "sales - small",
    SUPPORT: "support",
    UNKNOWN: "unknown",
    ERROR: "error"
};
var SALES_ENRICHMENT_PARAM_TYPES = {
    URL_PARAM: "url_param"
};
var _obj;
var AI_CONTACT_SALES_ANALYZER_RESPONSE_TO_HUBSPOT_FIELD_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, AI_ANALYZER_VALUES.SALES, "Sales"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, AI_ANALYZER_VALUES.SALES_SMALL, "Sales - small"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, AI_ANALYZER_VALUES.SUPPORT, "Support"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, AI_ANALYZER_VALUES.UNKNOWN, "Empty"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, AI_ANALYZER_VALUES.ERROR, "Error"), _obj);
var SALES_ENRICHMENT_PARAM_LIST = [
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_SOURCE,
        paramName: UTM_SOURCE
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CAMPAIGN,
        paramName: UTM_CAMPAIGN
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_BANNER,
        paramName: UTM_BANNER
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CONTENT,
        paramName: UTM_CONTENT
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_ADGROUP,
        paramName: UTM_ADGROUP
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_MEDIUM,
        paramName: UTM_MEDIUM
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_KEYWORD,
        paramName: UTM_KEYWORD
    },
    {
        hubspotApiName: HUBSPOT_API_NUMBER_OF_SEATS,
        paramName: NUMBER_OF_SEATS_PARAM
    }
];
var RECENT_CONVERSION_URL_QUERY_PARAM = "recent_conversion_url";


/***/ }),

/***/ 23155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ sendHubspotEligibleForWebsiteBotEvent; },
/* harmony export */   "OB": function() { return /* binding */ generateHiddenData; },
/* harmony export */   "Pw": function() { return /* binding */ sendHubspotForm; },
/* harmony export */   "WJ": function() { return /* binding */ submitHubspotForm; },
/* harmony export */   "kQ": function() { return /* binding */ sendHubspotBAMCalendarReachedEvent; },
/* harmony export */   "wB": function() { return /* binding */ getValueFromHSFields; }
/* harmony export */ });
/* unused harmony export getSingleUrlParamToHubspotForm */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10092);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64487);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8339);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22638);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67798);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29919);
/* harmony import */ var services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3223);
/* harmony import */ var services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14124);
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76127);
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(services_user_agent_service__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var services_contact_sales__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94445);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var HUBSPOT_FORM_URL = "https://api.hsforms.com/submissions/v3/integration/submit";
var HUBSPOT_CUSTOM_EVENT_URL = "/contact-sales/hs-event";
var submitHubspotForm = function() {
    var _ref = _async_to_generator(function(portalId, formId, emailValue) {
        var url, utmParams, data, serverResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(HUBSPOT_FORM_URL, "/").concat(portalId, "/").concat(formId);
                    utmParams = getUtmParams();
                    data = {
                        fields: [
                            {
                                name: "email",
                                value: emailValue
                            }
                        ].concat(utmParams)
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(data)
                        })
                    ];
                case 2:
                    serverResponse = _state.sent();
                    if (serverResponse.status !== 200) {
                        throw new Error(serverResponse.statusText);
                    }
                    return [
                        4,
                        serverResponse.json()
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 4:
                    err = _state.sent();
                    console.log("err", err);
                    return [
                        2,
                        false
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function submitHubspotForm(portalId, formId, emailValue) {
        return _ref.apply(this, arguments);
    };
}();
var sendHubspotEligibleForWebsiteBotEvent = function() {
    var _ref = _async_to_generator(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sendHubspotCustomEvent(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_EVENTS.ELIGIBLE_FOR_WEBSITE_BOT */ .fD.ELIGIBLE_FOR_WEBSITE_BOT)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function sendHubspotEligibleForWebsiteBotEvent() {
        return _ref.apply(this, arguments);
    };
}();
var sendHubspotBAMCalendarReachedEvent = function() {
    var _ref = _async_to_generator(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        sendHubspotCustomEvent(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_EVENTS.BAM_CALENDAR_REACHED */ .fD.BAM_CALENDAR_REACHED)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function sendHubspotBAMCalendarReachedEvent() {
        return _ref.apply(this, arguments);
    };
}();
var sendHubspotSubmissionEvent = function() {
    var _ref = _async_to_generator(function() {
        var properties;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    properties = {
                        is_existing_account: !!(0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_6__/* .isExistingAccount */ .vn)()
                    };
                    return [
                        4,
                        sendHubspotCustomEvent(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOM_EVENTS.FORM_SUBMISSION */ .fD.FORM_SUBMISSION, properties)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function sendHubspotSubmissionEvent() {
        return _ref.apply(this, arguments);
    };
}();
var getHiddenDataFromLocalStorage = function() {
    if (!localStorage) return [];
    var retVal = [];
    var contactSalesCta = localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_CTA */ .Wm);
    if (contactSalesCta) {
        retVal.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_CTA */ .Wm,
            value: contactSalesCta
        });
    }
    var contactSalesTranslated = localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_CTA_TRANSLATED */ .y8);
    if (contactSalesTranslated) {
        retVal.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_CTA_TRANSLATED */ .y8,
            value: contactSalesTranslated
        });
    }
    return retVal;
};
var sendHubspotCustomEvent = function() {
    var _ref = _async_to_generator(function(eventName, properties) {
        var defaultProperties, eventProperties, requestBody, response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    defaultProperties = getEventDefaultProperties();
                    eventProperties = _object_spread({}, defaultProperties, properties);
                    requestBody = JSON.stringify({
                        eventName: eventName,
                        properties: eventProperties
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(HUBSPOT_CUSTOM_EVENT_URL, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: requestBody
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (response.status !== 200 && response.status !== 204) {
                        throw new Error("status: ".concat(response.status, " message: ").concat(response.statusText));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .captureException */ .Tb(error);
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .captureMessage */ .uT("Failed to send hubspot custom event. request body: ".concat(requestBody, ", error: ").concat(error === null || error === void 0 ? void 0 : error.message));
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendHubspotCustomEvent(eventName, properties) {
        return _ref.apply(this, arguments);
    };
}();
var getUtmParams = function() {
    var url = window.location;
    var queryString = (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getQueryStringAsHash)(url);
    var utmParams = [];
    var utm_source = queryString.marketing_source || queryString.utm_source;
    if (utm_source) utmParams.push({
        name: "utm_source",
        value: utm_source
    });
    var utm_campaign = queryString.marketing_campaign || queryString.utm_campaign;
    if (utm_campaign) utmParams.push({
        name: "utm_campaign",
        value: utm_campaign
    });
    var utm_banner = queryString.marketing_banner || queryString.utm_banner;
    if (utm_banner) utmParams.push({
        name: "utm_banner",
        value: utm_banner
    });
    var utm_content = queryString.marketing_content || queryString.utm_content;
    if (utm_content) utmParams.push({
        name: "utm_content",
        value: utm_content
    });
    var utm_medium = queryString.marketing_medium || queryString.utm_medium;
    if (utm_medium) utmParams.push({
        name: "utm_medium",
        value: utm_medium
    });
    var utm_term = queryString.marketing_term || queryString.utm_term;
    if (utm_term) utmParams.push({
        name: "utm_term",
        value: utm_term
    });
    var utm_cluster_id = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_3__.CLUSTER_COOKIE);
    if (utm_cluster_id) utmParams.push({
        name: "utm_cluster_id",
        value: utm_cluster_id
    });
    return utmParams;
};
var getSingleUrlParamToHubspotForm = function(location, urlParamName, hubspotApiName) {
    return {
        name: hubspotApiName,
        value: (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getDecodedParamFromQuery)(location, urlParamName)
    };
};
var sendHubspotForm = function() {
    var _ref = _async_to_generator(function(portalId, formId, fields) {
        var sendHsEvent, HUBSPOT_ENDPOINT, hubspotCookie, prompt, intentHiddenField, hsFields, submissionRequest, ref, formSubmissionResult, submissionRequestResponse;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sendHsEvent = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                    if (!portalId || !formId) return [
                        2
                    ];
                    HUBSPOT_ENDPOINT = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(portalId, "/").concat(formId);
                    hubspotCookie = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("hubspotutk");
                    prompt = getValueFromHSFields(fields, _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_HOW_CAN_HELP */ .db);
                    return [
                        4,
                        getIntentHiddenField(prompt)
                    ];
                case 1:
                    intentHiddenField = _state.sent();
                    hsFields = intentHiddenField ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(fields).concat([
                        intentHiddenField
                    ]) : fields;
                    submissionRequest = fetch(HUBSPOT_ENDPOINT, {
                        method: "POST",
                        body: JSON.stringify({
                            fields: hsFields,
                            context: {
                                hutk: hubspotCookie
                            }
                        }),
                        headers: {
                            "content-type": "application/json"
                        }
                    });
                    if (!sendHsEvent) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.allSettled([
                            submissionRequest,
                            sendHubspotSubmissionEvent()
                        ])
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), formSubmissionResult = ref[0];
                    if (formSubmissionResult.status !== "fulfilled") {
                        throw formSubmissionResult.reason;
                    }
                    return [
                        2,
                        formSubmissionResult.value.json()
                    ];
                case 3:
                    return [
                        4,
                        submissionRequest
                    ];
                case 4:
                    submissionRequestResponse = _state.sent();
                    return [
                        2,
                        submissionRequestResponse.json()
                    ];
            }
        });
    });
    return function sendHubspotForm(portalId, formId, fields) {
        return _ref.apply(this, arguments);
    };
}();
var getRecentConversionUrl = function() {
    var _window_location, _window;
    return (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getDecodedParamFromQuery)(window.location, _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECENT_CONVERSION_URL_QUERY_PARAM */ .Cf) || ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href);
};
var generateHiddenData = function(param) {
    var withPrivacyNotice = param.withPrivacyNotice, source = param.source, overrideCampaignId = param.overrideCampaignId, abTests = param.abTests, cookies = param.cookies, cloudfrontViewerCountry = param.cloudfrontViewerCountry, referrePage = param.referrePage, bookAMeetingTestName = param.bookAMeetingTestName, hubspotFromHiddenField = param.hubspotFromHiddenField;
    var UTM_CAMPAIGN_PARAM_NAME = "utm_campaign";
    var urlParams = (0,services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_4__/* .getEnrichmentEntriesForSales */ .Xk)();
    if (overrideCampaignId) {
        var urlParamsWithoutCampaign = urlParams.filter(function(param) {
            return (param === null || param === void 0 ? void 0 : param.name) !== UTM_CAMPAIGN_PARAM_NAME;
        });
        urlParamsWithoutCampaign.push({
            name: UTM_CAMPAIGN_PARAM_NAME,
            value: overrideCampaignId
        });
        urlParams = urlParamsWithoutCampaign;
    }
    var hiddenData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(urlParams);
    var visitorId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_3__.BIG_BRAIN_VISITOR_ID) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_VISITOR */ .$K,
        value: visitorId
    });
    var pricingVersion = (0,services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_5__/* .getPricingVersionForSales */ .qM)({
        cookies: cookies,
        abTests: abTests,
        countryCode: cloudfrontViewerCountry
    }) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_PRICING_VERSION */ .lF,
        value: pricingVersion
    });
    var clusterId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_3__.CLUSTER_COOKIE) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_CLUSTER */ .Mj,
        value: clusterId
    });
    if (source) {
        hiddenData.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_SOURCE */ .rX,
            value: source
        });
    }
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_PRIVACY_CONSENT */ ._g,
        value: withPrivacyNotice
    });
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_RECENT_CONVERSION_URL */ .tT,
        value: getRecentConversionUrl()
    });
    if (referrePage) {
        hiddenData.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE */ .yM,
            value: referrePage
        });
    }
    if (bookAMeetingTestName) {
        hiddenData.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_AB_TEST_NAME */ .xT,
            value: bookAMeetingTestName
        });
    }
    if (hubspotFromHiddenField) {
        hiddenData.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_FROM */ .cj,
            value: hubspotFromHiddenField
        });
    } else {
        var fromUrlParamObject = getSingleUrlParamToHubspotForm(window.location, _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .URL_PARAM_FROM */ .sy, _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_FROM */ .cj);
        if (fromUrlParamObject.value) hiddenData.push(fromUrlParamObject);
    }
    var hiddenDataFromLocalStorage = getHiddenDataFromLocalStorage();
    if (hiddenDataFromLocalStorage.length > 0) {
        hiddenDataFromLocalStorage.forEach(function(item) {
            return hiddenData.push(item);
        });
    }
    return hiddenData;
};
var getIntentHiddenField = function() {
    var _ref = _async_to_generator(function(prompt) {
        var normalizedPrompt, aiPromptAnalysis, intent, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    normalizedPrompt = prompt === null || prompt === void 0 ? void 0 : prompt.trim();
                    if (!normalizedPrompt) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        (0,services_contact_sales__WEBPACK_IMPORTED_MODULE_8__/* .analyzeContactSalesIntent */ .Id)(normalizedPrompt)
                    ];
                case 1:
                    aiPromptAnalysis = _state.sent();
                    intent = aiPromptAnalysis === null || aiPromptAnalysis === void 0 ? void 0 : aiPromptAnalysis.intent;
                    return [
                        2,
                        {
                            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_AI_ANALYZER_FIELD_NAME */ .lG,
                            value: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .AI_CONTACT_SALES_ANALYZER_RESPONSE_TO_HUBSPOT_FIELD_MAP */ .ti[intent] || ""
                        }
                    ];
                case 2:
                    error = _state.sent();
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .captureMessage */ .uT("Failed to analyze contact sales intent: ".concat(error === null || error === void 0 ? void 0 : error.message));
                    return [
                        2,
                        {
                            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_CONTACT_SALES_AI_ANALYZER_FIELD_NAME */ .lG,
                            value: _hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .AI_CONTACT_SALES_ANALYZER_RESPONSE_TO_HUBSPOT_FIELD_MAP */ .ti[_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .AI_ANALYZER_VALUES.ERROR */ .gu.ERROR]
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getIntentHiddenField(prompt) {
        return _ref.apply(this, arguments);
    };
}();
var getValueFromHSFields = function(fields, fieldName) {
    var _fields_find;
    return fields === null || fields === void 0 ? void 0 : (_fields_find = fields.find(function(field) {
        return field.name === fieldName;
    })) === null || _fields_find === void 0 ? void 0 : _fields_find.value;
};
var getEventDefaultProperties = function() {
    var _JSON_parse, _JSON_parse1, _JSON_parse2, _JSON_parse3, _JSON_parse4;
    var userAgentAnalytics = (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_7__.getClientDeviceDetails)();
    return {
        hs_referrer: document.referrer,
        hs_page_url: window.location.href,
        hs_page_title: document.title,
        hs_utm_source: (_JSON_parse = JSON.parse(localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_UTM_SOURCE */ .Oe))) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.value,
        hs_utm_medium: (_JSON_parse1 = JSON.parse(localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_UTM_MEDIUM */ .s))) === null || _JSON_parse1 === void 0 ? void 0 : _JSON_parse1.value,
        hs_utm_campaign: (_JSON_parse2 = JSON.parse(localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_UTM_CAMPAIGN */ .nZ))) === null || _JSON_parse2 === void 0 ? void 0 : _JSON_parse2.value,
        hs_utm_term: (_JSON_parse3 = JSON.parse(localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_UTM_TERM */ .bn))) === null || _JSON_parse3 === void 0 ? void 0 : _JSON_parse3.value,
        hs_utm_content: (_JSON_parse4 = JSON.parse(localStorage.getItem(_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .HUBSPOT_API_UTM_CONTENT */ .Yk))) === null || _JSON_parse4 === void 0 ? void 0 : _JSON_parse4.value,
        hs_browser: userAgentAnalytics.browser,
        hs_device_type: userAgentAnalytics.device_type,
        hs_device_name: userAgentAnalytics.device,
        hs_operating_system: userAgentAnalytics.operating_system,
        hs_operating_version: userAgentAnalytics.operating_version
    };
};


/***/ }),

/***/ 1909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_z_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35257);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footerText: "",
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    style: {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: "".concat(constants_z_index__WEBPACK_IMPORTED_MODULE_0__/* .MODAL_BACKGROUND */ .AE)
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            padding: "0",
            border: "none",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            minHeight: "630px",
            minWidth: "960px",
            overflow: "hidden",
            borderRadius: "16px"
        }
    },
    isOpen: false
});


/***/ }),

/***/ 60202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ YoutubeVideoModalComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/Icon.js
var Icon = __webpack_require__(41114);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Close.js
var Close = __webpack_require__(55831);
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-footer/modal-footer-component.scss.js


var StyledModalFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehv20jh0"
})("display:flex;align-items:center;justify-content:center;transform:scale(0.9);.modal-footer-text{color:", colors/* default.white */.Z.white, ";outline:none;font-size:1.125rem;}.modal-footer-signup-wrapper{width:55%;margin-left:16px;}");

;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-footer/modal-footer-component.js








var ModalFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalFooterComponent);
    function ModalFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, ModalFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ModalFooterComponent, [
        {
            key: "render",
            value: function render() {
                var footerText = this.props.footerText;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalFooterComponent, {
                    className: "modal-footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                focusOnLoad: true,
                                placement: "modal_footer"
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ModalFooterComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-content/modal-content-component.scss.js


var StyledModalWithSignupContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1buq9i0"
})("overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;border-radius:18px;.modal-footer-wrapper{background-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";padding:8px 0;width:100%;}");

// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-content/modal-content-component.js










var ModalWithSignupContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalWithSignupContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalWithSignupContentComponent);
    function ModalWithSignupContentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ModalWithSignupContentComponent);
        var _this;
        _this = _super.call(this, props);
        _this.handleClickOutside = _this.handleClickOutside.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ModalWithSignupContentComponent, [
        {
            key: "handleClickOutside",
            value: function handleClickOutside() {
                this.props.onCloseModal();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, footerText = _props.footerText, onCloseModal = _props.onCloseModal, style = _props.style, withSignup = _props.withSignup;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalWithSignupContentComponent, {
                    className: "modal-content-wrapper",
                    style: {
                        minHeight: style.content.minHeight,
                        minWidth: style.content.minWidth
                    },
                    children: [
                        children,
                        withSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooterComponent, {
                                footerText: footerText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ModalWithSignupContentComponent;
}(react.PureComponent);
ModalWithSignupContentComponent.defaultProps = {
    withSignup: true
};
/* harmony default export */ var modal_content_component = ((0,react_onclickoutside_es/* default */.Z)(ModalWithSignupContentComponent));

;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-with-signup-component.scss.js

var StyledCloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bcka210"
})("position:absolute;top:-24px;right:-24px;font-size:2.25rem;font-weight:400;opacity:0.7;transition:opacity 0.1s ease-in-out;cursor:pointer;outline:none;color:white;display:flex;&:hover{opacity:1;}");

// EXTERNAL MODULE: ./components/core/modal-with-signup/default-props.js
var default_props = __webpack_require__(1909);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-with-signup-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var ModalWithSignupComponent = function(props) {
    var onCloseModal = props.onCloseModal;
    (0,react.useEffect)(function() {
        lib_default().setAppElement("body");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                className: "close-button",
                onClick: onCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                    iconType: (Icon_default()).type.SVG,
                    icon: (Close_default()),
                    iconSize: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_content_component, _object_spread({}, props))
        ]
    }));
};
ModalWithSignupComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var modal_with_signup_component = (ModalWithSignupComponent);

// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
;// CONCATENATED MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.scss.js

var StyledYoutubeVideoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16vng0v0"
})("background-color:rgba(255,255,255,0.7);span{display:flex;}");

;// CONCATENATED MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js




function youtube_video_modal_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_modal_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_modal_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var YoutubeVideoModalComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YoutubeVideoModalComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YoutubeVideoModalComponent);
    function YoutubeVideoModalComponent() {
        (0,_class_call_check/* default */.Z)(this, YoutubeVideoModalComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(YoutubeVideoModalComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, isOpen = _props.isOpen, onCloseModal = _props.onCloseModal, footerText = _props.footerText, style = _props.style, withSignup = _props.withSignup;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_with_signup_component, {
                    style: style,
                    footerText: footerText,
                    isOpen: isOpen,
                    onCloseModal: onCloseModal,
                    withSignup: withSignup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYoutubeVideoWrapper, {
                        className: "youtube-video-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, youtube_video_modal_component_object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return YoutubeVideoModalComponent;
}(react.PureComponent);

YoutubeVideoModalComponent.defaultProps = {
    withSignup: true
};


/***/ }),

/***/ 14831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ youtube_video_component; }
});

// UNUSED EXPORTS: YOUTUBE_EMBEDED_HOST, YOUTUBE_EMBEDED_NOCOOKIE_HOST

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/youtube-video/youtube-video-component.scss.js

var StyledYouTubeVideoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exohynt0"
})(".video-container{display:flex;flex-direction:column;text-align:center;align-items:center;justify-content:center;height:100%;width:100%;.content{display:flex;iframe{display:block;}&.with-shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}}}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/index.esm.js
var index_esm = __webpack_require__(5406);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies-categories.js
var cookies_categories = __webpack_require__(41140);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./components/core/youtube-video/youtube-video-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var DEFAULT_PLAYER_VARS = {
    modestbranding: 1,
    controls: 1,
    rel: 0,
    frameBorder: 0,
    showinfo: 1,
    playsinline: 0
};
var DEFAULT_OPTS = {
    playerVars: DEFAULT_PLAYER_VARS
};
var YOUTUBE_EMBEDED_HOST = "https://www.youtube.com";
var YOUTUBE_EMBEDED_NOCOOKIE_HOST = "https://www.youtube-nocookie.com";
var YouTubeVideoComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YouTubeVideoComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YouTubeVideoComponent);
    function YouTubeVideoComponent(props) {
        (0,_class_call_check/* default */.Z)(this, YouTubeVideoComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "onPlay", function(event) {
            var _props = _this.props, onPlay = _props.onPlay, videoId = _props.videoId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.YOUTUBE_VIDEO_STARTED, {
                kind: videoId
            });
            if (onPlay) onPlay(event);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "onEnd", function(event) {
            var _props = _this.props, onEnd = _props.onEnd, videoId = _props.videoId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.YOUTUBE_VIDEO_ENDED, {
                kind: videoId
            });
            if (onEnd) onEnd(event);
        });
        _this.onReady = _this.onReady.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this._player = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(YouTubeVideoComponent, [
        {
            key: "onReady",
            value: function onReady(event) {
                var _props = this.props, onReady1 = _props.onReady, playing = _props.playing;
                this._player = event.target;
                this.toggleMute();
                this.setVolume();
                if (playing) {
                    // We want do to it only if playing = true so we don't pause the video.
                    this.togglePlay();
                }
                onReady1(event);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.muted !== prevProps.muted) {
                    this.toggleMute();
                }
                if (this.props.playing !== prevProps.playing) {
                    this.togglePlay();
                }
                if (this.props.volume !== prevProps.volume) {
                    this.setVolume();
                }
            }
        },
        {
            key: "toggleMute",
            value: function toggleMute() {
                var muted = this.props.muted;
                if (!this._player) {
                    return;
                }
                if (muted) {
                    this._player.mute();
                } else {
                    this._player.unMute();
                }
            }
        },
        {
            key: "togglePlay",
            value: function togglePlay() {
                var playing = this.props.playing;
                if (!this._player) {
                    return;
                }
                if (playing) {
                    this._player.playVideo();
                } else {
                    this._player.pauseVideo();
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume() {
                var volume = this.props.volume;
                if (!this._player || volume === null) {
                    return;
                }
                this._player.setVolume(volume);
            }
        },
        {
            key: "getYoutubeHost",
            value: function getYoutubeHost() {
                return (0,cookies_service/* isInClientAndCookieCategoryNotApproved */.P0)(cookies_categories.COOKIE_CATEGORIES.MARKETING) //GDPR relevant - in other countries Marketing category is always approved
                 ? YOUTUBE_EMBEDED_NOCOOKIE_HOST : YOUTUBE_EMBEDED_HOST;
            }
        },
        {
            key: "generateOpts",
            value: function generateOpts() {
                var opts = this.props.opts;
                return _object_spread_props(_object_spread({}, opts), {
                    host: this.getYoutubeHost()
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, videoId = _props.videoId, background = _props.background, showShadow = _props.showShadow;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYouTubeVideoComponent, {
                    className: "youtube-video-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("video-container", (0,_define_property/* default */.Z)({}, background, background)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("content", {
                                "with-shadow": showShadow
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                                videoId: videoId,
                                onReady: this.onReady,
                                opts: this.generateOpts(),
                                onEnd: this.onEnd,
                                onPlay: this.onPlay
                            }))
                        })
                    })
                });
            }
        }
    ]);
    return YouTubeVideoComponent;
}(react.PureComponent);
YouTubeVideoComponent.defaultProps = {
    playing: false,
    volume: null,
    muted: false,
    onReady: function() {},
    onEnd: function() {},
    onPlay: function() {},
    opts: DEFAULT_OPTS
};
/* harmony default export */ var youtube_video_component = ((0,generic_config_context/* withGenericConfig */.P)(YouTubeVideoComponent));


/***/ }),

/***/ 61980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ACCOUNT_PERMISSIONS": function() { return /* binding */ ACCOUNT_PERMISSIONS; },
  "ACTIVITY_LOG": function() { return /* binding */ ACTIVITY_LOG; },
  "ADVANCED_COLUMN_TYPES": function() { return /* binding */ ADVANCED_COLUMN_TYPES; },
  "ADVANCED_CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ ADVANCED_CUSTOMER_PROJECT_MANAGEMENT; },
  "APPROVED_GUEST": function() { return /* binding */ APPROVED_GUEST; },
  "AUDIT_LOG": function() { return /* binding */ AUDIT_LOG; },
  "AUTOMATIONS": function() { return /* binding */ AUTOMATIONS; },
  "BLOCK_DOMAINS": function() { return /* binding */ BLOCK_DOMAINS; },
  "BOARDS": function() { return /* binding */ BOARDS; },
  "BOARD_ADMINISTRATORS": function() { return /* binding */ features_BOARD_ADMINISTRATORS; },
  "CALENDAR": function() { return /* binding */ features_CALENDAR; },
  "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
  "COLLABORATIVE_WHITEBOARD": function() { return /* binding */ COLLABORATIVE_WHITEBOARD; },
  "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
  "COMMISSION_MANAGEMENT": function() { return /* binding */ COMMISSION_MANAGEMENT; },
  "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
  "CONTENT_DIRECTORY": function() { return /* binding */ CONTENT_DIRECTORY; },
  "CS_MANAGER": function() { return /* binding */ CS_MANAGER; },
  "CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ CUSTOMER_PROJECT_MANAGEMENT; },
  "CUSTOMIZABLE_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZABLE_NOTIFICATIONS; },
  "CUSTOMIZABLE_SALES_PROCESS": function() { return /* binding */ CUSTOMIZABLE_SALES_PROCESS; },
  "CUSTOM_DASHBOARDS": function() { return /* binding */ CUSTOM_DASHBOARDS; },
  "CUSTOM_ROLES": function() { return /* binding */ CUSTOM_ROLES; },
  "DAILY_REPORTS": function() { return /* binding */ DAILY_REPORTS; },
  "DASHBOARDS": function() { return /* binding */ features_DASHBOARDS; },
  "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
  "DEPENDENCY_COLUMN": function() { return /* binding */ DEPENDENCY_COLUMN; },
  "EMAIL_SUPPORT": function() { return /* binding */ EMAIL_SUPPORT; },
  "EMBEDDED_BOARD": function() { return /* binding */ EMBEDDED_BOARD; },
  "EMBED_DOCUMENTS_AND_BRIEFS": function() { return /* binding */ EMBED_DOCUMENTS_AND_BRIEFS; },
  "FILES_MANAGEMENT": function() { return /* binding */ FILES_MANAGEMENT; },
  "FORMS": function() { return /* binding */ features_FORMS; },
  "FORMS_CUSTOMIZATION": function() { return /* binding */ FORMS_CUSTOMIZATION; },
  "FORMULA": function() { return /* binding */ FORMULA; },
  "GOOGLE": function() { return /* binding */ GOOGLE; },
  "GUESTS": function() { return /* binding */ features_GUESTS; },
  "HIPAA": function() { return /* binding */ HIPAA; },
  "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
  "IMPORT_FROM_OTHER_TOOLS": function() { return /* binding */ IMPORT_FROM_OTHER_TOOLS; },
  "INTEGRATIONS": function() { return /* binding */ features_INTEGRATIONS; },
  "INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK": function() { return /* binding */ INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK; },
  "INTEGRATION_PERMISSIONS": function() { return /* binding */ INTEGRATION_PERMISSIONS; },
  "IP_RESTRICTIONS": function() { return /* binding */ IP_RESTRICTIONS; },
  "ITEMS": function() { return /* binding */ ITEMS; },
  "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
  "KNOWLEDGE_BASE": function() { return /* binding */ KNOWLEDGE_BASE; },
  "LEAD_ASSIGNMENT": function() { return /* binding */ LEAD_ASSIGNMENT; },
  "MAP": function() { return /* binding */ MAP; },
  "MARKETING_CALENDAR": function() { return /* binding */ MARKETING_CALENDAR; },
  "MARKETING_DASHBOARDS": function() { return /* binding */ MARKETING_DASHBOARDS; },
  "MARKETING_INTEGRATIONS": function() { return /* binding */ MARKETING_INTEGRATIONS; },
  "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
  "MAXIMUM_SEATS": function() { return /* binding */ MAXIMUM_SEATS; },
  "MOBILE": function() { return /* binding */ MOBILE; },
  "PANIC_MODE": function() { return /* binding */ features_PANIC_MODE; },
  "PIVOT_ANALYSIS": function() { return /* binding */ PIVOT_ANALYSIS; },
  "PREMIUM_INTEGRATIONS": function() { return /* binding */ PREMIUM_INTEGRATIONS; },
  "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
  "PRIVATE_WORKSPACES": function() { return /* binding */ PRIVATE_WORKSPACES; },
  "READY_MADE_MARKETING_TEMPLATES": function() { return /* binding */ READY_MADE_MARKETING_TEMPLATES; },
  "SALESFORCE_INTEGRATION": function() { return /* binding */ SALESFORCE_INTEGRATION; },
  "SAML": function() { return /* binding */ SAML; },
  "SCHEDULED_DASHBOARD_DELIVERY": function() { return /* binding */ SCHEDULED_DASHBOARD_DELIVERY; },
  "SCIM": function() { return /* binding */ SCIM; },
  "SEARCH": function() { return /* binding */ SEARCH; },
  "SEATS_MANAGEMENT": function() { return /* binding */ SEATS_MANAGEMENT; },
  "SESSIONS": function() { return /* binding */ SESSIONS; },
  "SHARE_BOARD_WITH_EXTERNAL_GUESTS": function() { return /* binding */ SHARE_BOARD_WITH_EXTERNAL_GUESTS; },
  "SLA": function() { return /* binding */ SLA; },
  "SOC": function() { return /* binding */ SOC; },
  "STORAGE": function() { return /* binding */ STORAGE; },
  "TAGS": function() { return /* binding */ TAGS; },
  "TEAMS_INSIDE_TEAMS": function() { return /* binding */ TEAMS_INSIDE_TEAMS; },
  "TEMPLATES": function() { return /* binding */ TEMPLATES; },
  "TENANT_RESTRICTIONS": function() { return /* binding */ TENANT_RESTRICTIONS; },
  "TIMELINE": function() { return /* binding */ TIMELINE; },
  "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
  "TWO_FA": function() { return /* binding */ TWO_FA; },
  "TWO_WAY_EMAIL_SYNC": function() { return /* binding */ TWO_WAY_EMAIL_SYNC; },
  "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
  "UNLIMITED_BOARDS_WITH_FREE_TIER": function() { return /* binding */ UNLIMITED_BOARDS_WITH_FREE_TIER; },
  "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
  "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
  "UPDATES_SECTION": function() { return /* binding */ UPDATES_SECTION; },
  "VIEWERS": function() { return /* binding */ VIEWERS; },
  "WEBINARS": function() { return /* binding */ WEBINARS; },
  "WEB_TO_LEAD_CAPTURING": function() { return /* binding */ WEB_TO_LEAD_CAPTURING; },
  "WHITEBOARD": function() { return /* binding */ features_WHITEBOARD; },
  "WORKLOAD": function() { return /* binding */ WORKLOAD; },
  "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; },
  "ZOOM_INTEGRATION": function() { return /* binding */ ZOOM_INTEGRATION; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./constants/free-tier.js
var ITEM_RESOURCE_CREDIT_FOR_FREE_TIER = 200;
var USER_RESOURCE_CREDIT_FOR_FREE_TIER = 2; // every visitor to the homepage gets the same value, regardless of free tier version.

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./services/ab-tests/free-tier-item-resource-credit-sync-service.js




var getItemResourceCreditCount = function(abTests, cookies) {
    var forcedItemResourceCreditFromPlatform = cookies[constants_cookies.MONDAY_FREE_TIER_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME];
    if (forcedItemResourceCreditFromPlatform) return parseInt(forcedItemResourceCreditFromPlatform);
    var resourceCreditAmount = ITEM_RESOURCE_CREDIT_FOR_FREE_TIER;
    if ((0,dom_utils_service.isRunningInClient)()) (0,cookies_service/* setCookie */.d8)(constants_cookies.HOMEPAGE_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME, resourceCreditAmount);
    return resourceCreditAmount;
};

// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features_tiers.js


var _obj;
var GENERIC_ALL_TRUE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj);
var _obj1;
var ENTERPRISE_ONLY = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj1);
var WHITEBOARD = GENERIC_ALL_TRUE;
var _obj2;
var INTEGRATIONS = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.integrations_standard"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.integrations_pro"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.integrations_enterprise"
}), _obj2);
var FORMS = GENERIC_ALL_TRUE;
var _obj3;
var GUESTS = (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.guests_four_one"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.unlimited"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.unlimited"
}), _obj3);
var _obj4;
var DASHBOARDS = (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.dashboards_standard"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.dashboards_pro"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.dashboards_enterprise"
}), _obj4);
var _obj5;
var CALENDAR = (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj5);
var _obj6;
var SCHEDULED_DASHBOARD_DELIVVERY = (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj6);
var _obj7;
var BOARD_ADMINISTRATORS = (_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj7);
var _obj8;
var PANIC_MODE = (_obj8 = {}, (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj8);

// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var FILES_MANAGEMENT = {
    name: "pricingPage.features.titles.filesManagement",
    description: "pricingPage.features.descriptions.filesManagement",
    tiers: GENERIC_ALL_TRUE
};
var LEAD_ASSIGNMENT = {
    name: "pricingPage.features.titles.leadAssignment",
    description: "pricingPage.features.descriptions.leadAssignment",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_SALES_PROCESS = {
    name: "pricingPage.features.titles.customizableSalesProcess",
    description: "pricingPage.features.descriptions.customizableSalesProcess",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.customerProjectManagement",
    description: "pricingPage.features.descriptions.customerProjectManagement",
    tiers: GENERIC_ALL_TRUE
};
var WEB_TO_LEAD_CAPTURING = {
    name: "pricingPage.features.titles.webToLeadCapturing",
    description: "pricingPage.features.descriptions.webToLeadCapturing",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOM_DASHBOARDS = {
    name: "pricingPage.features.titles.customDashboards",
    description: "pricingPage.features.descriptions.customDashboards",
    tiers: GENERIC_ALL_TRUE
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    description: "pricingPage.features.descriptions.communication_with_context",
    tiers: GENERIC_ALL_TRUE
};
var COLLABORATIVE_WHITEBOARD = {
    name: "pricingPage.features.titles.collaborative_whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK = {
    name: "pricingPage.features.titles.integrations_with_gmail_and_outlook",
    description: "pricingPage.features.descriptions.integrations_with_gmail_and_outlook",
    tiers: INTEGRATIONS
};
var IMPORT_FROM_OTHER_TOOLS = {
    name: "pricingPage.features.titles.importFromOtherTools",
    description: "pricingPage.features.descriptions.importFromOtherTools",
    tiers: GENERIC_ALL_TRUE
};
var EMBED_DOCUMENTS_AND_BRIEFS = {
    name: "pricingPage.features.titles.embed_documents_and_briefs",
    description: "pricingPage.features.descriptions.embed_documents_and_briefs",
    tiers: GENERIC_ALL_TRUE
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    description: "pricingPage.features.descriptions.marketing_requests_with_forms",
    tiers: FORMS
};
var READY_MADE_MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    description: "pricingPage.features.descriptions.ready_made_marketing_templates",
    tiers: GENERIC_ALL_TRUE
};
var TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    description: "pricingPage.features.descriptions.templates",
    tiers: GENERIC_ALL_TRUE
};
var UPDATES_SECTION = {
    name: "pricingPage.features.titles.updatesSection",
    description: "pricingPage.features.descriptions.updatesSection",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizableNotifications",
    description: "pricingPage.features.descriptions.customizableNotifications",
    tiers: GENERIC_ALL_TRUE
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    description: "pricingPage.features.descriptions.deadline_management",
    tiers: GENERIC_ALL_TRUE
};
var SHARE_BOARD_WITH_EXTERNAL_GUESTS = {
    name: "pricingPage.features.titles.share_board_with_external_guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var MARKETING_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.marketing_integrations",
    tiers: INTEGRATIONS
};
var MARKETING_DASHBOARDS = {
    name: "pricingPage.features.titles.dashboards",
    description: "pricingPage.features.descriptions.marketing_dashboards",
    tiers: DASHBOARDS
};
var MARKETING_CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    description: "pricingPage.features.descriptions.marketing_calendar",
    tiers: CALENDAR
};
var DAILY_REPORTS = {
    name: "pricingPage.features.titles.daily_reports",
    description: "pricingPage.features.descriptions.daily_reports",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    description: "pricingPage.features.descriptions.import_export_excel",
    tiers: GENERIC_ALL_TRUE
};
var features_WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var EMBEDDED_BOARD = {
    name: "pricingPage.features.titles.embed_docs",
    description: "pricingPage.features.descriptions.embed_docs",
    tiers: GENERIC_ALL_TRUE
};
var features_obj;
var ZOOM_INTEGRATION = {
    name: "pricingPage.features.titles.zoom_integration",
    description: "pricingPage.features.descriptions.zoom_integration",
    tiers: (features_obj = {}, (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj)
};
var TIMELINE = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.timeline",
        description: "pricingPage.features.descriptions.timeline",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_CALENDAR = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.calendar",
        description: "pricingPage.features.descriptions.calendar",
        tiers: _object_spread_props(_object_spread({}, CALENDAR), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }))
    };
};
var features_GUESTS = {
    name: "pricingPage.features.titles.guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    description: "pricingPage.features.descriptions.kanbanView",
    tiers: GENERIC_ALL_TRUE
};
var WEBINARS = {
    name: "pricingPage.features.titles.webinars",
    description: "pricingPage.features.descriptions.webinars",
    tiers: GENERIC_ALL_TRUE
};
var features_FORMS = {
    name: "pricingPage.features.titles.forms",
    description: "pricingPage.features.descriptions.forms",
    tiers: FORMS
};
var features_obj1;
var MAP = {
    name: "pricingPage.features.titles.map",
    description: "pricingPage.features.descriptions.map",
    tiers: (features_obj1 = {}, (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj1)
};
var features_obj2;
var SEARCH = {
    name: "pricingPage.features.titles.search",
    description: "pricingPage.features.descriptions.search",
    tiers: (features_obj2 = {}, (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj2)
};
var features_obj3;
var IP_RESTRICTIONS = {
    name: "pricingPage.features.titles.ip_restrictions",
    description: "pricingPage.features.descriptions.ip_restrictions",
    tiers: (features_obj3 = {}, (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj3)
};
var features_obj4;
var CONTENT_DIRECTORY = {
    name: "pricingPage.features.titles.content_directory",
    description: "pricingPage.features.descriptions.content_directory",
    tiers: (features_obj4 = {}, (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj4)
};
var TEAMS_INSIDE_TEAMS = {
    name: "pricingPage.features.titles.teams_inside_teams",
    description: "pricingPage.features.descriptions.teams_inside_teams",
    tiers: ENTERPRISE_ONLY
};
var CUSTOM_ROLES = {
    name: "pricingPage.features.titles.custom_roles",
    description: "pricingPage.features.descriptions.custom_roles",
    tiers: ENTERPRISE_ONLY
};
var SEATS_MANAGEMENT = {
    name: "pricingPage.features.titles.seats_management",
    description: "pricingPage.features.descriptions.seats_management",
    tiers: ENTERPRISE_ONLY
};
var TENANT_RESTRICTIONS = {
    name: "pricingPage.features.titles.tenant_restrictions",
    description: "pricingPage.features.descriptions.tenant_restrictions",
    tiers: ENTERPRISE_ONLY
};
var APPROVED_GUEST = {
    name: "pricingPage.features.titles.approved_guest",
    description: "pricingPage.features.descriptions.approved_guest",
    tiers: ENTERPRISE_ONLY
};
var BLOCK_DOMAINS = {
    name: "pricingPage.features.titles.block_domains",
    description: "pricingPage.features.descriptions.block_domains",
    tiers: ENTERPRISE_ONLY
};
var FORMS_CUSTOMIZATION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formsCustomization",
        description: "pricingPage.features.descriptions.formsCustomization",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_obj5;
var TWO_WAY_EMAIL_SYNC = {
    name: "pricingPage.features.titles.twoWayEmailSync",
    description: "pricingPage.features.descriptions.twoWayEmailSync",
    tiers: (features_obj5 = {}, (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj5)
};
var features_obj6;
var COMMISSION_MANAGEMENT = {
    name: "pricingPage.features.titles.commissionManagement",
    description: "pricingPage.features.descriptions.commissionManagement",
    tiers: (features_obj6 = {}, (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj6)
};
var features_obj7;
var ADVANCED_CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedCustomerProjectManagement",
    description: "pricingPage.features.descriptions.advancedCustomerProjectManagement",
    tiers: (features_obj7 = {}, (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj7)
};
var features_obj8;
var WORKLOAD = {
    name: "pricingPage.features.titles.workload",
    description: "pricingPage.features.descriptions.workload",
    tiers: (features_obj8 = {}, (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj8)
};
var _obj9;
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    description: "pricingPage.features.descriptions.timeTracking",
    tiers: (_obj9 = {}, (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj9)
};
var CHART_VIEW = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.chartView",
        description: "pricingPage.features.descriptions.chartView",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var FORMULA = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formula",
        description: "pricingPage.features.descriptions.formula",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj10;
var DEPENDENCY_COLUMN = {
    name: "pricingPage.features.titles.dependencyColumn",
    description: "pricingPage.features.descriptions.dependencyColumn",
    tiers: (_obj10 = {}, (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj10)
};
var _obj11;
var TAGS = {
    name: "pricingPage.features.titles.tags",
    description: "pricingPage.features.descriptions.tags",
    tiers: (_obj11 = {}, (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj11)
};
var _obj12;
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    description: "pricingPage.features.descriptions.privateBoards",
    tiers: (_obj12 = {}, (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj12)
};
var features_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.integrations",
    tiers: INTEGRATIONS
};
var _obj13;
var AUTOMATIONS = {
    name: "pricingPage.features.titles.automations",
    description: "pricingPage.features.descriptions.automations",
    tiers: (_obj13 = {}, (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.automations_standard"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.automations_pro"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.automations_enterprise"
    }), _obj13)
};
var _obj14;
var PREMIUM_INTEGRATIONS = {
    name: "pricingPage.features.titles.premiumIntegrations",
    description: "pricingPage.features.descriptions.premiumIntegrations",
    tiers: (_obj14 = {}, (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj14)
};
var features_DASHBOARDS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.dashboards",
        description: "pricingPage.features.descriptions.dashboards",
        tiers: _object_spread_props(_object_spread({}, DASHBOARDS), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: "pricingPage.features.plans.dashboards_pro"
        } : {
            value: "pricingPage.features.plans.dashboards_basic"
        }))
    };
};
var TWO_FA = {
    name: "pricingPage.features.titles.twoFa",
    description: "pricingPage.features.descriptions.twoFa",
    tiers: GENERIC_ALL_TRUE
};
var _obj15;
var GOOGLE = {
    name: "pricingPage.features.titles.google",
    description: "pricingPage.features.descriptions.google",
    tiers: (_obj15 = {}, (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj15)
};
var features_BOARD_ADMINISTRATORS = {
    name: "pricingPage.features.titles.boardAdministrators",
    description: "pricingPage.features.descriptions.boardAdministrators",
    tiers: BOARD_ADMINISTRATORS
};
var _obj16;
var SAML = {
    name: "pricingPage.features.titles.saml",
    description: "pricingPage.features.descriptions.saml",
    tiers: (_obj16 = {}, (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj16)
};
var _obj17;
var SCIM = {
    name: "pricingPage.features.titles.scimProvisioning",
    description: "pricingPage.features.descriptions.scimProvisioning",
    tiers: (_obj17 = {}, (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj17)
};
var _obj18;
var AUDIT_LOG = {
    name: "pricingPage.features.titles.auditLog",
    description: "pricingPage.features.descriptions.auditLog",
    tiers: (_obj18 = {}, (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj18)
};
var _obj19;
var SESSIONS = {
    name: "pricingPage.features.titles.sessions",
    description: "pricingPage.features.descriptions.sessions",
    tiers: (_obj19 = {}, (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj19)
};
var features_PANIC_MODE = {
    name: "pricingPage.features.titles.panicMode",
    description: "pricingPage.features.descriptions.panicMode",
    tiers: PANIC_MODE
};
var _obj20;
var HIPAA = {
    name: "pricingPage.features.titles.hipaa",
    description: "pricingPage.features.descriptions.hipaa",
    tiers: (_obj20 = {}, (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj20)
};
var SOC = {
    name: "pricingPage.features.titles.soc",
    description: "pricingPage.features.descriptions.soc",
    tiers: GENERIC_ALL_TRUE
};
var _obj21;
var SLA = {
    name: "pricingPage.features.titles.sla",
    description: "pricingPage.features.descriptions.sla",
    tiers: (_obj21 = {}, (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj21)
};
var _obj22;
var CS_MANAGER = {
    name: "pricingPage.features.titles.csManager",
    description: "pricingPage.features.descriptions.csManager",
    tiers: (_obj22 = {}, (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj22)
};
var _obj23;
var INTEGRATION_PERMISSIONS = {
    name: "pricingPage.features.titles.integrationPermissions",
    description: "pricingPage.features.descriptions.integrationPermissions",
    tiers: (_obj23 = {}, (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj23)
};
var _obj24;
var SALESFORCE_INTEGRATION = {
    name: "pricingPage.features.titles.salesforceIntegration",
    description: "pricingPage.features.descriptions.salesforceIntegration",
    tiers: (_obj24 = {}, (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj24)
};
var _obj25;
var PRIVATE_WORKSPACES = {
    name: "pricingPage.features.titles.privateWorkspaces",
    description: "pricingPage.features.descriptions.privateWorkspaces",
    tiers: (_obj25 = {}, (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj25)
};
var _obj26;
var ACCOUNT_PERMISSIONS = {
    name: "pricingPage.features.titles.accountPermissions",
    description: "pricingPage.features.descriptions.accountPermissions",
    tiers: (_obj26 = {}, (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj26)
};
var _obj27;
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    description: "pricingPage.features.descriptions.workPerformanceInsights",
    tiers: (_obj27 = {}, (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj27)
};
var SCHEDULED_DASHBOARD_DELIVERY = {
    name: "pricingPage.features.titles.dashboardEmailNotifications",
    description: "pricingPage.features.descriptions.dashboardEmailNotifications",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var _obj28;
var PIVOT_ANALYSIS = {
    name: "pricingPage.features.titles.pivotAnalysis",
    description: "pricingPage.features.descriptions.pivotAnalysis",
    tiers: (_obj28 = {}, (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj28)
};
var KNOWLEDGE_BASE = {
    name: "pricingPage.features.titles.knowledgeBase",
    description: "pricingPage.features.descriptions.knowledgeBase",
    tiers: GENERIC_ALL_TRUE
};
var EMAIL_SUPPORT = {
    name: "pricingPage.features.titles.emailSupport",
    description: "pricingPage.features.descriptions.emailSupport",
    tiers: GENERIC_ALL_TRUE
};
var _obj29;
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj29 = {}, (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj29)
};
var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    description: "pricingPage.features.descriptions.boards",
    tiers: GENERIC_ALL_TRUE
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    description: "pricingPage.features.descriptions.docs",
    tiers: GENERIC_ALL_TRUE
};
var COLUMN_TYPES = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.columnTypes",
        description: "pricingPage.features.descriptions.columnTypes",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsFreeOver20ColumnTypes */._n)({
                cookies: cookies
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj30;
var MAXIMUM_SEATS = {
    name: "pricingPage.features.titles.maximumSeats",
    description: "pricingPage.features.descriptions.maximumSeats",
    tiers: (_obj30 = {}, (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.FREE */.Iy.FREE, {
        value: {
            key: "pricingPage.upToXSeats",
            param: pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3
        }
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj30)
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    description: "pricingPage.features.descriptions.mobile",
    tiers: GENERIC_ALL_TRUE
};
var STORAGE = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, false) ? BIGGER_STORAGE_FEATURE : STORAGE_FEATURE;
};
var _obj31;
var STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    description: "pricingPage.features.descriptions.storage",
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj31 = {}, (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise"
    }), _obj31)
};
var _obj32;
var BIGGER_STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    description: "pricingPage.features.descriptions.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj32 = {}, (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro_bigger"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise_bigger"
    }), _obj32)
};
var _obj33;
var ACTIVITY_LOG = {
    name: "pricingPage.features.titles.activityLog",
    description: "pricingPage.features.descriptions.activityLog",
    tiers: (_obj33 = {}, (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.six_months"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.one_year"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.five_years"
    }), _obj33)
};
var _obj34;
var ADVANCED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.advancedColumnTypes",
    description: "pricingPage.features.descriptions.columnTypes",
    tiers: (_obj34 = {}, (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj34)
};
var _obj35;
var VIEWERS = {
    name: "pricingPage.features.titles.viewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj35 = {}, (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj35)
};
var _obj36;
var BOARDS = {
    name: "pricingPage.features.titles.boards",
    description: "pricingPage.features.descriptions.boards",
    tiers: (_obj36 = {}, (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj36)
};
var ITEMS = function(param) {
    var abTests = param.abTests, cookies = param.cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.items",
        description: {
            key: "pricingPage.features.descriptions.items",
            param: getItemResourceCreditCount(abTests, cookies)
        },
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: "pricingPage.features.plans.upToOneK"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: "pricingPage.features.plans.unlimited"
        }), _obj)
    };
};
var UNLIMITED_BOARDS_WITH_FREE_TIER = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var _obj;
    return {
        name: "pricingPage.features.titles.unlimitedBoards",
        description: "pricingPage.features.descriptions.boards",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsUnlimitedBoards */.J6)({
                cookies: cookies,
                abTests: abTests
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};


/***/ }),

/***/ 16168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K8": function() { return /* binding */ SECURITY_AND_PRIVACY; },
/* harmony export */   "Kk": function() { return /* binding */ CUSTOMER_FAVORITES; },
/* harmony export */   "QA": function() { return /* binding */ SUPPORT_NEW; },
/* harmony export */   "RV": function() { return /* binding */ REMOTE_WORK_FEATURES_SECTION; },
/* harmony export */   "UO": function() { return /* binding */ ADVANCED; },
/* harmony export */   "VG": function() { return /* binding */ getDefaultSections; },
/* harmony export */   "Xn": function() { return /* binding */ ADMINISTRATION_AND_CONTROL; },
/* harmony export */   "_h": function() { return /* binding */ SECURITY_NEW; },
/* harmony export */   "iz": function() { return /* binding */ COLLABORATION; },
/* harmony export */   "k3": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "lG": function() { return /* binding */ SECURITY; },
/* harmony export */   "nD": function() { return /* binding */ PRODUCTIVITY; },
/* harmony export */   "uK": function() { return /* binding */ VIEWS_AND_REPORTING; },
/* harmony export */   "wL": function() { return /* binding */ SUPPORT; },
/* harmony export */   "zw": function() { return /* binding */ ENTERPRISE_REPORTING_AND_ANALYTICS; }
/* harmony export */ });
/* unused harmony export NEW_PRICING_PAGE_DEFAULT_SECTIONS */
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var CUSTOMER_FAVORITES = function(param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies;
    return {
        sectionName: "pricingPage.features.sections.customer_favorites",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.IMPORT_FROM_OTHER_TOOLS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS
        ]
    };
};
var COLLABORATION = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasFreeTier = param.hasFreeTier, hasStudentPlan = param.hasStudentPlan;
    var featuresList = [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.UPDATES_SECTION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS
    ];
    if (!(hasFreeTier || hasStudentPlan)) {
        // otherwise, the following features already appear via the 'ESSENTIALS' section.
        featuresList.unshift(_features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS);
        featuresList.push(_features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
            cookies: cookies,
            abTests: abTests
        }));
    }
    return {
        sectionName: "pricingPage.features.sections.collaboration",
        features: featuresList
    };
};
var PRODUCTIVITY = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.productivity",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOMIZABLE_NOTIFICATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN
        ]
    };
};
var VIEWS_AND_REPORTING = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.views_and_reporting",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD
        ]
    };
};
// Newest, winning version.
var SUPPORT_NEW = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WEBINARS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CS_MANAGER,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA
    ]
};
// New, winning version.
var SECURITY_AND_PRIVACY = {
    sectionName: "pricingPage.features.sections.security_and_privacy",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TEAMS_INSIDE_TEAMS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOM_ROLES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SEATS_MANAGEMENT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TENANT_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.APPROVED_GUEST,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BLOCK_DOMAINS
    ]
};
var ADMINISTRATION_AND_CONTROL = {
    sectionName: "pricingPage.features.sections.administration_and_control",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BOARD_ADMINISTRATORS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PANIC_MODE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ENTERPRISE_REPORTING_AND_ANALYTICS = {
    sectionName: "pricingPage.features.sections.enterprise_reporting_and_analytics",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
var NEW_PRICING_PAGE_DEFAULT_SECTIONS = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return [
        CUSTOMER_FAVORITES({
            hasStudentPlan: hasStudentPlan,
            cookies: cookies
        }),
        COLLABORATION({
            cookies: cookies,
            abTests: abTests,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        }),
        PRODUCTIVITY({
            hasStudentPlan: hasStudentPlan
        }),
        VIEWS_AND_REPORTING({
            hasStudentPlan: hasStudentPlan
        }),
        SUPPORT_NEW,
        SECURITY_AND_PRIVACY,
        ADMINISTRATION_AND_CONTROL,
        ENTERPRISE_REPORTING_AND_ANALYTICS
    ];
};
var REMOTE_WORK_FEATURES_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.remote_work",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var ADVANCED = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.SEARCH,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TAGS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
// Old version, before any tests. Kept here until we're 100% sure none of the clusters use it.
var SECURITY = {
    sectionName: "pricingPage.features.sections.security",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ADVANCED_REPORTING = {
    sectionName: "pricingPage.features.sections.advancedReporting",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
// Old version, kept until we're certain none of the clusters use it.
var SUPPORT = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT
    ]
};
// Newer version, of a successful test.
var SECURITY_NEW = {
    sectionName: "pricingPage.features.sections.security_new",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY
    ]
};
var getDefaultSections = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return NEW_PRICING_PAGE_DEFAULT_SECTIONS({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};


/***/ }),

/***/ 8876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getFreeTierEssentials; }
/* harmony export */ });
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var getFreeTierEssentials = function(abTests, cookies) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ITEMS({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS_WITH_FREE_TIER({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_DOCS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS
        ]
    };
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getDefaultTierDescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}

var _obj;
var DEFAULT_TIER_DESCRIPTIONS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, "pricingPage.tierDescriptions.individual.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, "pricingPage.tierDescriptions.basic.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, "pricingPage.tierDescriptions.standard.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, "pricingPage.tierDescriptions.pro.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, "pricingPage.tierDescriptions.enterprise.new"), _obj);
var getDefaultTierDescriptions = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var tierDescriptions = _object_spread({}, DEFAULT_TIER_DESCRIPTIONS);
    if (hasStudentPlan) {
        tierDescriptions[constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE] = "pricingPage.tierDescriptions.student";
    }
    return tierDescriptions;
};


/***/ }),

/***/ 69078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DEFAULT_VALUE_FEATURES_PER_TIER; },
/* harmony export */   "v": function() { return /* binding */ getDefaultValueFeatures; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78217);
/* harmony import */ var services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46724);




var DEFAULT_VALUE_FEATURES_PER_TIER = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var withoutBasic = (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .shouldHideBasic */ .gd)({
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, hasStudentPlan ? _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STUDENT_PLAN_VALUE_FEATURES */ .b5 : (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .getFreeTierFeaturesByAbTest */ .EF)({
        cookies: cookies,
        forcePricing: forcePricing
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .BASIC_TIER_VALUE_FEATURES */ .cN)({
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STANDARD_TIER_VALUE_FEATURES */ .kh)({
        withoutBasic: withoutBasic,
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .PRO_TIER_VALUE_FEATURES */ .tE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .ENTERPRISE_TIER_VALUE_FEATURES */ .$4), _obj;
};
var getDefaultValueFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return DEFAULT_VALUE_FEATURES_PER_TIER({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
};


/***/ }),

/***/ 44363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ IPO_CAMPAIGN_ID; },
/* harmony export */   "S": function() { return /* binding */ GARTNER_CAMPAIGN_ID; }
/* harmony export */ });
var IPO_CAMPAIGN_ID = "ipo_promotion";
var GARTNER_CAMPAIGN_ID = "gartner_campaign";


/***/ }),

/***/ 29238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VIDEO_OPTS; }
/* harmony export */ });
var VIDEO_OPTS = {
    width: 970,
    height: 546,
    playerVars: {
        autoplay: 1,
        rel: 0,
        showinfo: 0
    }
};


/***/ }),

/***/ 11068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/default-props.js
var default_props = __webpack_require__(28601);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var regular_button_default_props = __webpack_require__(57578);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var two_link_buttons_button_default_props = ({
    secondaryButtonConfig: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
        buttonText: "Learn more"
    }),
    regularButtonConfig: _object_spread_props(_object_spread({}, regular_button_default_props/* default */.Z), {
        buttonText: "Get a demo",
        buttonSize: button_component.LG
    })
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/two-link-buttons-button.scss.js


var StyledTwoLinkButtonsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euz44uy0"
})("display:flex;align-items:center;gap:24px;&.swap-buttons-order{flex-direction:row-reverse;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:column-reverse;gap:24px;&.swap-buttons-order{flex-direction:column;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/two-link-buttons-button.js




function two_link_buttons_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_link_buttons_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_link_buttons_button_define_property(target, key, source[key]);
        });
    }
    return target;
}







var TwoLinkButtonsButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoLinkButtonsButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoLinkButtonsButton);
    function TwoLinkButtonsButton() {
        (0,_class_call_check/* default */.Z)(this, TwoLinkButtonsButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoLinkButtonsButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, secondaryButtonConfig = _props.secondaryButtonConfig, regularButtonConfig = _props.regularButtonConfig, swapButtonsOrder = _props.swapButtonsOrder;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTwoLinkButtonsButton, {
                    className: classnames_default()("two-link-buttons-button", {
                        "swap-buttons-order": swapButtonsOrder
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, two_link_buttons_button_object_spread({}, secondaryButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, two_link_buttons_button_object_spread({}, regularButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return TwoLinkButtonsButton;
}(react.PureComponent);

TwoLinkButtonsButton.defaultProps = two_link_buttons_button_default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/default-props.js
var signup_button_default_props = __webpack_require__(47436);
;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var signup_combo_buttons_button_default_props = ({
    signupButtonConfig: signup_button_default_props/* default */.Z,
    secondaryButtonConfig: default_props_object_spread_props(default_props_object_spread({}, default_props/* default */.Z), {
        buttonText: "Learn more"
    })
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/signup-combo-buttons-button.scss.js


var StyledSignupComboButtonsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19ejvdf0"
})("display:flex;align-items:center;gap:24px;&.swap-buttons-order{flex-direction:row-reverse;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){&.swap-buttons-order{flex-direction:column;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/signup-combo-buttons-button.js




function signup_combo_buttons_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_combo_buttons_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_combo_buttons_button_define_property(target, key, source[key]);
        });
    }
    return target;
}







var SignupComboButtonsButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupComboButtonsButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupComboButtonsButton);
    function SignupComboButtonsButton() {
        (0,_class_call_check/* default */.Z)(this, SignupComboButtonsButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupComboButtonsButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, secondaryButtonConfig = _props.secondaryButtonConfig, signupButtonConfig = _props.signupButtonConfig, swapButtonsOrder = _props.swapButtonsOrder;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupComboButtonsButton, {
                    className: classnames_default()("signup-combo-buttons-button", swapButtonsOrder && "swap-buttons-order"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, signup_combo_buttons_button_object_spread({}, signupButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, signup_combo_buttons_button_object_spread({}, secondaryButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return SignupComboButtonsButton;
}(react.PureComponent);

SignupComboButtonsButton.defaultProps = signup_combo_buttons_button_default_props;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-service.js
var hubspot_service = __webpack_require__(23155);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/inputs/email-input-component.js + 1 modules
var email_input_component = __webpack_require__(89766);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/default-props.js
/* harmony default export */ var email_button_default_props = ({});

// EXTERNAL MODULE: ./components/enhancements/input-error-handler/input-error-handler.js + 1 modules
var input_error_handler = __webpack_require__(84640);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/email-button.scss.js




var StyledEmailButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mjlvrz0"
})("margin:8px 0px;width:100%;.email-button-inner{display:flex;justify-content:center;height:50px;input{font-size:0.875rem;line-height:8px;padding:12px 24px;border-radius:40px;font-size:1rem;-webkit-appearance:none;//Remove shadow from input in mobile safari\n\n      background-color:", colors/* default.light-grey */.Z["light-grey"], ";color:", colors/* default.black */.Z.black, ";border:1px solid;border-color:", colors/* default.grey */.Z.grey, ";outline:none;text-align:left;transition:border-color 0.1s ease-in-out;margin-right:16px;&:hover::placeholder,&:focus::placeholder{color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}&:focus{border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default.white */.Z.white, ";}}&.error input,&.error input:focus{border-color:", colors/* default.error */.Z.error, ";}button.ladda-button.sm{font-size:0.875rem;}.only-button{min-width:300px;}.email-button-wrapper{.email-button-class{min-width:130px;.email-button-arrow-wrapper{padding-left:18px;svg{fill:currentColor;height:12px;}}}}}.notice-text-wrapper{margin-top:8px;padding-left:24px;font-size:0.8125rem;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){&:not(.force-horizontal){.email-button-inner{flex-direction:column;text-align:center;input{margin-bottom:16px;font-size:0.875rem;padding:16px 8px;margin-right:0;text-align:center;min-width:264px;}.email-button-wrapper{width:100%;button{font-size:0.875rem;padding:16px 48px;width:100%;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/email-button.js





function email_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}










var DEFAULT_CTA_KEY = "signup.cta";
var EmailButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmailButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmailButton);
    function EmailButton(props) {
        (0,_class_call_check/* default */.Z)(this, EmailButton);
        var _this;
        _this = _super.call(this, props);
        email_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "focusOnInput", function() {
            _this._emailInput && _this._emailInput.focus();
        });
        _this._emailInput = null;
        _this.updateEmail = _this.updateEmail.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleOnClickIfNeeded = _this.handleOnClickIfNeeded.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(EmailButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, focusOnLoad = _props.focusOnLoad, isFirstSegment = _props.isFirstSegment, isPreview = _props.isPreview;
                if (isPreview) return;
                var shouldFocus = focusOnLoad || isFirstSegment;
                shouldFocus && this.focusOnInput();
            }
        },
        {
            key: "updateEmail",
            value: function updateEmail(event) {
                var _props = this.props, errorStateCallback = _props.errorStateCallback, onEmailChange = _props.onEmailChange;
                errorStateCallback(false);
                onEmailChange(event.target.value);
            }
        },
        {
            key: "getButtonText",
            value: function getButtonText() {
                var _props = this.props, buttonText = _props.buttonText, translate = _props.translate;
                return buttonText || translate(DEFAULT_CTA_KEY); //removed from default props because of localization
            }
        },
        {
            key: "getPlaceholderText",
            value: function getPlaceholderText() {
                var _props = this.props, placeholder = _props.placeholder, translate = _props.translate;
                return placeholder || translate("signup.emailInputPlaceholder");
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                var _props = this.props, errorStateCallback = _props.errorStateCallback, onButtonClick = _props.onButtonClick, emailValue = _props.emailValue;
                if (!emailValue) {
                    BigBrain("track", bigbrain_event_types.CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL);
                }
                if (!this._emailInput.isValid()) {
                    errorStateCallback(true);
                    return;
                }
                onButtonClick();
            }
        },
        {
            key: "handleOnClickIfNeeded",
            value: function handleOnClickIfNeeded(event) {
                if (event.key === "Enter") {
                    this.onClick();
                    event.preventDefault();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, emailValue = _props.emailValue, buttonColor = _props.buttonColor, buttonSize = _props.buttonSize, isErrorState = _props.isErrorState, className = _props.className, borderColor = _props.borderColor, disableButtonAnimation = _props.disableButtonAnimation, placeholderFocusColor = _props.placeholderFocusColor, withButtonArrow = _props.withButtonArrow, buttonSpinnerColor = _props.buttonSpinnerColor, isLoading = _props.isLoading, noticeText = _props.noticeText;
                var buttonTextToUse = this.getButtonText();
                var placeholderToUse = this.getPlaceholderText();
                var clickAction = this.onClick;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmailButton, {
                    className: classnames_default()("email-button", className, {
                        error: isErrorState
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "email-button-inner",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(email_input_component/* default */.Z, {
                                    className: "email-button-input",
                                    ref: function(el) {
                                        return _this._emailInput = el;
                                    },
                                    value: emailValue,
                                    onChange: this.updateEmail,
                                    placeholder: placeholderToUse,
                                    onKeyPress: this.handleOnClickIfNeeded,
                                    autoComplete: "on",
                                    placeholderFocusColor: placeholderFocusColor,
                                    style: {
                                        borderColor: borderColor
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "email-button-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_button_component/* default */.Z, {
                                        className: "email-button-class",
                                        color: buttonColor,
                                        size: buttonSize,
                                        isLoading: isLoading,
                                        onClickCallback: clickAction,
                                        disableAnimation: disableButtonAnimation,
                                        dataSpinnerColor: buttonSpinnerColor,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "button-text",
                                                children: buttonTextToUse
                                            }),
                                            withButtonArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "email-button-arrow-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        noticeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "notice-text-wrapper",
                            children: noticeText
                        })
                    ]
                });
            }
        }
    ]);
    return EmailButton;
}(react.PureComponent);
EmailButton.defaultProps = email_button_default_props;
/* harmony default export */ var email_button = ((0,input_error_handler/* default */.Z)((0,generic_config_context/* withGenericConfig */.P)(EmailButton)));

// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/default-props.js
/* harmony default export */ var subscribe_button_default_props = ({
    buttonText: "Subscribe"
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/subscribe-button.scss.js

var StyledSubscribeButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etj7kzy0"
})();

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/subscribe-button.js






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function subscribe_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function subscribe_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            subscribe_button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function subscribe_button_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function subscribe_button_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        subscribe_button_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var FORM_GUID = "e13c9bb3-29ee-4ef1-b5b9-78d946c95502";
var SubscribeButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SubscribeButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SubscribeButton);
    function SubscribeButton(props) {
        (0,_class_call_check/* default */.Z)(this, SubscribeButton);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        subscribe_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onButtonClick", /*#__PURE__*/ _async_to_generator(function() {
            var _state, subscribed, emailValue, res;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this1.state, subscribed = _state.subscribed, emailValue = _state.emailValue;
                        _this1.trackEvent(bigbrain_event_types.CLICKED_SUBSCRIBE_BUTTON);
                        if (!!subscribed) return [
                            3,
                            2
                        ];
                        _this1.setState({
                            isButtonLoading: true
                        });
                        _this1.trackEvent(bigbrain_event_types.SUBSCRIPTION_REQUESTED);
                        return [
                            4,
                            (0,hubspot_service/* submitHubspotForm */.WJ)(contact_form_config/* PORTAL_ID */.Im, FORM_GUID, emailValue)
                        ];
                    case 1:
                        res = _state1.sent();
                        if (res) {
                            _this1.trackEvent(bigbrain_event_types.SUBSCRIPTION_SUCCESS);
                            _this1.setState({
                                isButtonLoading: false,
                                subscribed: true,
                                emailValue: ""
                            });
                        }
                        _state1.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }));
        subscribe_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onEmailChange", function(emailValue) {
            _this.setState({
                emailValue: emailValue,
                subscribed: false
            });
        });
        _this.state = {
            isButtonLoading: false,
            subscribed: false,
            emailValue: ""
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(SubscribeButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.trackEvent(bigbrain_event_types.SUBSCRIBE_BUTTON_RENDERED);
            }
        },
        {
            key: "trackEvent",
            value: function trackEvent(eventName) {
                var router = this.props.router;
                BigBrain("track", bigbrain_event_types.SUBSCRIBE_BUTTON_BIGBRAIN_EVENT_NAME, {
                    kind: eventName,
                    placement: router.asPath
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, isButtonLoading = _state.isButtonLoading, subscribed = _state.subscribed, emailValue = _state.emailValue;
                var translate = this.props.translate;
                var noticeText = subscribed && !emailValue ? translate("button.thankYou") : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubscribeButton, {
                    className: "signup-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(email_button, subscribe_button_object_spread_props(subscribe_button_object_spread({}, this.props), {
                        emailValue: emailValue,
                        onButtonClick: this.onButtonClick,
                        onEmailChange: this.onEmailChange,
                        isLoading: isButtonLoading,
                        borderColor: "gray",
                        noticeText: noticeText
                    }))
                });
            }
        }
    ]);
    return SubscribeButton;
}(react.PureComponent);
SubscribeButton.defaultProps = subscribe_button_default_props;
/* harmony default export */ var subscribe_button = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(SubscribeButton)));

// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js + 3 modules
var youtube_popup_button = __webpack_require__(25101);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/default-props.js
var youtube_popup_button_default_props = __webpack_require__(62129);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/default-props.js
function signup_and_youtube_combo_button_default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_and_youtube_combo_button_default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_and_youtube_combo_button_default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var signup_and_youtube_combo_button_default_props = ({
    signupButtonConfig: signup_and_youtube_combo_button_default_props_object_spread({}, signup_button_default_props/* default */.Z),
    youtubePopupButtonConfig: signup_and_youtube_combo_button_default_props_object_spread({}, youtube_popup_button_default_props/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/signup-and-youtube-combo-button.scss.js


var StyledSignupAndYoutubeComboButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewfh8mi0"
})("display:flex;align-items:flex-start;gap:24px;.secondary-button-wrapper{height:50px;display:flex;align-items:center;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:column;align-items:center;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/signup-and-youtube-combo-button.js




function signup_and_youtube_combo_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_and_youtube_combo_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_and_youtube_combo_button_define_property(target, key, source[key]);
        });
    }
    return target;
}






var SignupAndYoutubeComboButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupAndYoutubeComboButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupAndYoutubeComboButton);
    function SignupAndYoutubeComboButton() {
        (0,_class_call_check/* default */.Z)(this, SignupAndYoutubeComboButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupAndYoutubeComboButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, youtubePopupButtonConfig = _props.youtubePopupButtonConfig, signupButtonConfig = _props.signupButtonConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupAndYoutubeComboButton, {
                    className: "signup-and-youtube-combo-button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, signup_and_youtube_combo_button_object_spread({}, signupButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_popup_button/* default */.Z, signup_and_youtube_combo_button_object_spread({}, youtubePopupButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return SignupAndYoutubeComboButton;
}(react.PureComponent);

SignupAndYoutubeComboButton.defaultProps = signup_and_youtube_combo_button_default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button.scss.js

var StyledButtton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo7hf3m0"
})();

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/default-props.js

/* harmony default export */ var button_default_props = ({
    buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button.js




function button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













var Button = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Button, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Button);
    function Button() {
        (0,_class_call_check/* default */.Z)(this, Button);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Button, [
        {
            key: "getButtonComponent",
            value: function getButtonComponent() {
                var buttonType = this.props.buttonType;
                switch(buttonType){
                    case button_consts/* REGULAR_BUTTON_TYPE */.ys:
                        return regular_button/* default */.Z;
                    case button_consts/* SECONDARY_BUTTON_TYPE */.jE:
                        return secondary_button/* default */.Z;
                    case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                        return signup_button/* default */.Z;
                    case button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_:
                        return TwoLinkButtonsButton;
                    case button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae:
                        return SignupComboButtonsButton;
                    case button_consts/* SUBSCRIBE_BUTTON_TYPE */.$j:
                        return subscribe_button;
                    case button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9:
                        return youtube_popup_button/* default */.Z;
                    case button_consts/* SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE */.iF:
                        return SignupAndYoutubeComboButton;
                    default:
                        return null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var ButtonComponent = this.getButtonComponent();
                if (!ButtonComponent) return null;
                var _this_props = this.props, buttonType = _this_props.buttonType, restButtonConfig = _object_without_properties(_this_props, [
                    "buttonType"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtton, {
                    className: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, button_object_spread({}, restButtonConfig))
                });
            }
        }
    ]);
    return Button;
}(react.PureComponent);

Button.defaultProps = button_default_props;


/***/ }),

/***/ 57578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35061);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);
/* harmony import */ var constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87154);



/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonSize: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__.MD,
    buttonText: "Button",
    isOpenLinkInNewTab: false,
    onClick: null,
    color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    isWithArrow: true,
    minPadding: false,
    additionalText: null,
    additionalTextPosition: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__/* .BELOW */ ._,
    additionalTextMaxWidth: null,
    iconRenderer: null,
    extraEventData: {}
});


/***/ }),

/***/ 35662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.scss.js

var StyledRegularButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e633rko0"
})("&.full{width:100%;}.additional-button-text{margin-top:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var default_props = __webpack_require__(57578);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}















var isSeoFriendlyUrl = function(url) {
    var res = false;
    if (url && url.indexOf(links/* MONDAY_AUTH_DOMAIN */.NyZ) < 0) {
        res = true;
    }
    return res;
};
var RegularButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularButton);
    function RegularButton(props) {
        (0,_class_call_check/* default */.Z)(this, RegularButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, buttonText = _props.buttonText, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, onClick = _props.onClick, extraEventData = _props.extraEventData;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.REGULAR_BUTTON_CLICKED, {
                kind: buttonText,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: url,
                info3: (0,utils_url.getLastPartOfUrl)(url),
                data: extraEventData
            });
            if (onClick) {
                onClick(e);
            }
            if (url && !_this.isSeoFriendlyUrl) {
                if (isOpenLinkInNewTab) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonBackgroundColor", function(color) {
            if (color === color_consts.DODGER_BLUE_COLOR_NAME || color === color_consts.SPACE_BLUE_COLOR_NAME) {
                return color_consts.WORK_OS_IRIS_COLOR_NAME;
            }
            return color;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonStrippedText", function() {
            var buttonText = _this.props.buttonText;
            var disallowedButtonChars = [
                /\s*>/g
            ];
            var strippedButtonText = buttonText;
            disallowedButtonChars.forEach(function(ending) {
                strippedButtonText = strippedButtonText.replace(ending, "");
            });
            return strippedButtonText;
        });
        _this.isSeoFriendlyUrl = isSeoFriendlyUrl(props.url);
        return _this;
    }
    (0,_create_class/* default */.Z)(RegularButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, buttonSize = _props.buttonSize, color = _props.color, outline = _props.outline, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, minPadding = _props.minPadding, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, additionalText = _props.additionalText, additionalTextPosition = _props.additionalTextPosition, additionalTextMaxWidth = _props.additionalTextMaxWidth, className = _props.className;
                var buttonStyle = button_service/* buttonStyles */.$Y[color] || {};
                var textColor = buttonStyle.textColor, backgroundColorName = buttonStyle.backgroundColorName;
                var buttonColor = this.getButtonBackgroundColor(backgroundColorName);
                var buttonStrippedText = this.getButtonStrippedText();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularButton, {
                    className: classnames_default()("regular-button", buttonSize, additionalText && "additional-text additional-text-".concat(additionalTextPosition)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.ZP, {
                            seoFriendlyUrl: this.isSeoFriendlyUrl && url,
                            isOpenLinkInNewTab: isOpenLinkInNewTab,
                            size: buttonSize,
                            onClick: this.onClick,
                            color: buttonColor,
                            textColor: textColor,
                            outline: outline,
                            isWithArrow: isWithArrow,
                            className: className,
                            iconRenderer: iconRenderer,
                            minPadding: minPadding,
                            children: buttonStrippedText
                        }),
                        additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("additional-button-text", this.additionalTextPosition),
                            style: {
                                maxWidth: additionalTextMaxWidth
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                text: additionalText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RegularButton;
}(react.PureComponent);
RegularButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var regular_button = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(RegularButton)));


/***/ }),

/***/ 28601:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonText: "Button",
    isWithArrow: true,
    color: "black",
    onClick: undefined,
    withoutUnderline: false
});


/***/ }),

/***/ 95736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ secondary_button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./static/svg/arrow-right-3.svg
var arrow_right_3 = __webpack_require__(58462);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/default-props.js
var default_props = __webpack_require__(28601);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.scss.js


var StyledSecondaryButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1f4h8u20"
})("font-size:0.875rem;font-weight:700;line-height:24px;display:flex;a{display:flex;align-items:center;text-decoration:none;&.with-underline{background:linear-gradient(to right,var(--underline-color-with-opacity),var(--underline-color-with-opacity)),linear-gradient(to right,var(--underline-color),var(--underline-color),var(--underline-color));background-size:100% 1px,0 1px;background-position:100% 100%,0 100%;background-repeat:no-repeat;transition:", button_consts/* UNDERLINE_TRANSITION */.Mw, ";&.with-icon{background-size:calc(100% - 48px) 1px,0px 1px;background-position:100% 100%,48px 100%;}&.with-icon-instead-of-arrow{background-size:100% 1px,0px 1px;background-position:100% 100%,0px 100%;}&:hover,&:focus{background-size:0 1px,100% 1px;}}}.left-side-icon{margin-right:16px;}.arrow-wrapper{padding-left:8px;padding-right:4px;margin-right:-4px;transition:", button_consts/* ARROW_TRANSITION */.NY, ";svg{fill:currentColor;height:10px;width:12px;}}.icon-instead-of-arrow-wrapper{display:flex;padding-left:8px;.play-wrapper{padding-right:0;svg{width:16px;}}}&:hover{.arrow-wrapper{padding-left:12px;padding-right:0px;}}");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var SecondaryButton = function(props) {
    var buttonText = props.buttonText, url = props.url, isOpenLinkInNewTab = props.isOpenLinkInNewTab, color = props.color, isWithArrow = props.isWithArrow, iconRenderer = props.iconRenderer, isWithIconInsteadOfArrow = props.isWithIconInsteadOfArrow, withoutUnderline = props.withoutUnderline, onClick = props.onClick, platformUrl = props.platformUrl, leftSideIcon = props.leftSideIcon;
    var buttonUrl = platformUrl && (0,existing_accounts_service/* isExistingAccount */.vn)() ? (0,existing_accounts_service/* getMondayUrl */.Xm)(platformUrl) : url;
    var onButtonClick = function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SECONDARY_BUTTON_CLICKED, {
            kind: buttonText,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: buttonUrl,
            info3: (0,utils_url.getLastPartOfUrl)(buttonUrl)
        });
        if (onClick) {
            onClick(e);
        }
    };
    var getButtonColor = function(accessibleColor) {
        if (accessibleColor === color_consts.DODGER_BLUE_COLOR_NAME) return color_consts.SPACE_BLUE_COLOR_NAME;
        if (accessibleColor === color_consts.ELEVATE_BUTTON_GRADIANT_COLOR_NAME) return color_consts.WHITE_COLOR_NAME;
        return accessibleColor;
    };
    var accessibleColor = (0,accessibility_service/* getAccessibleButtonColor */.ef)(color);
    var finalColor = getButtonColor(accessibleColor);
    var showIcon = iconRenderer && !isWithIconInsteadOfArrow;
    var showArrow = isWithArrow && !isWithIconInsteadOfArrow;
    var showIconInsteadOfArrow = isWithIconInsteadOfArrow && iconRenderer;
    var aProps = {
        style: {
            color: colors/* default */.Z[finalColor],
            "--underline-color": colors/* default */.Z[finalColor],
            "--underline-color-with-opacity": (0,general/* hexToRgba */.a7)(colors/* default */.Z[finalColor], 0.4)
        }
    };
    if (buttonUrl) {
        aProps = _object_spread_props(_object_spread({}, aProps), {
            href: buttonUrl,
            target: isOpenLinkInNewTab ? "_blank" : "_self"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSecondaryButton, {
        className: "secondary-button",
        children: [
            leftSideIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "left-side-icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                    image: {
                        src: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.src
                    },
                    width: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.size
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", _object_spread_props(_object_spread({}, aProps), {
                onClick: onButtonClick,
                className: classnames_default()({
                    "with-icon": iconRenderer,
                    "with-icon-instead-of-arrow": showIconInsteadOfArrow,
                    "with-underline": !withoutUnderline
                }),
                children: [
                    showIcon && iconRenderer(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "secondary-button-text",
                        children: buttonText
                    }),
                    showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "arrow-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_3/* default */.Z, {})
                    }),
                    showIconInsteadOfArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "icon-instead-of-arrow-wrapper",
                        children: iconRenderer()
                    })
                ]
            }))
        ]
    });
};
SecondaryButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var secondary_button = ((0,ab_tests_context/* withAbTests */.k)(SecondaryButton));


/***/ }),

/***/ 47436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87154);

/* harmony default export */ __webpack_exports__["Z"] = ({
    withButtonArrow: true,
    additionalText: null,
    additionalTextPosition: _constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_0__/* .BELOW */ ._,
    additionalTextMaxWidth: null
});


/***/ }),

/***/ 85850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/signups/regular-signup-component/regular-signup-component.js + 1 modules
var regular_signup_component = __webpack_require__(74115);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/default-props.js
var default_props = __webpack_require__(47436);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.scss.js

var StyledSignupButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eb0ljuq0"
})();

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SignupButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupButton);
    function SignupButton() {
        (0,_class_call_check/* default */.Z)(this, SignupButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupButton, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSignupButton, {
                    className: "signup-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_signup_component/* default */.Z, _object_spread({
                        withButtonArrow: false
                    }, this.props))
                });
            }
        }
    ]);
    return SignupButton;
}(react.PureComponent);

SignupButton.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 62129:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonText: "Button",
    isWithArrow: true,
    color: "black",
    isWithIcon: false,
    iconColor: "green",
    isWithIconInsteadOfArrow: false,
    outline: false,
    minPadding: false
});


/***/ }),

/***/ 25101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ youtube_popup_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
;// CONCATENATED MODULE: ./static/svg/videos/video-play-core-button-v4.svg
var _circle, _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgVideoPlayCoreButtonV4 = function SvgVideoPlayCoreButtonV4(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 16,
        cy: 16,
        r: 15.3,
        stroke: "#323338",
        strokeWidth: 1.4
    })), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#323338",
        d: "M23.833 15.134a1 1 0 0 1 0 1.732l-11 6.35a1 1 0 0 1-1.5-.865V9.649a1 1 0 0 1 1.5-.866z"
    })));
};
/* harmony default export */ var video_play_core_button_v4 = (SvgVideoPlayCoreButtonV4);

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./components/core/modal-with-signup/default-props.js
var default_props = __webpack_require__(1909);
// EXTERNAL MODULE: ./constants/youtube-modal.js
var youtube_modal = __webpack_require__(29238);
;// CONCATENATED MODULE: ./static/svg/icons/play.svg
var play_path, _path2;
function play_extends() {
    play_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return play_extends.apply(this, arguments);
}

var SvgPlay = function SvgPlay(props) {
    return /*#__PURE__*/ react.createElement("svg", play_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), play_path || (play_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "m8.79 12.924 3.947-2.437a.583.583 0 0 0 0-.974L8.789 7.076C8.44 6.86 8 7.13 8 7.564v4.873c0 .433.439.703.79.487"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M5.404 5.404a6.5 6.5 0 1 1 9.192 9.192 6.5 6.5 0 0 1-9.192-9.192",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var play = (SvgPlay);

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/default-props.js
var youtube_popup_button_default_props = __webpack_require__(62129);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.scss.js

var StyledYouTubePopUpButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej8vwev0"
})(".secondary-button-wrapper{&:hover{outline:0;}}.play-wrapper{padding-right:16px;svg{display:block;circle{stroke:currentColor;}path{fill:currentColor;}}&.regular-button{padding-right:4px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var MIN_HEIGHT = 546;
var WINDOW_INITIAL_WIDTH = 780;
var WINDOW_INITIAL_HEIGHT = 928;
var YouTubePopUpButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YouTubePopUpButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YouTubePopUpButton);
    function YouTubePopUpButton(props) {
        (0,_class_call_check/* default */.Z)(this, YouTubePopUpButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getVideoOpts", function() {
            var _state = _this.state, windowHeight = _state.windowHeight, windowWidth = _state.windowWidth;
            var isMobileOrTabletBrowser = _this.props.isMobileOrTabletBrowser;
            var videoOpts = _object_spread_props(_object_spread({}, youtube_modal/* VIDEO_OPTS */.C), {
                height: windowHeight
            });
            if (isMobileOrTabletBrowser) {
                videoOpts = _object_spread_props(_object_spread({}, videoOpts), {
                    width: windowWidth
                });
            }
            return videoOpts;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getModalStyle", function() {
            var isMobileOrTabletBrowser = _this.props.isMobileOrTabletBrowser;
            var style = default_props/* default.style */.Z.style;
            var minWidthProp = isMobileOrTabletBrowser ? {
                minWidth: "unset",
                minHeight: "unset"
            } : {
                minWidth: "960px"
            };
            return _object_spread_props(_object_spread({}, style), {
                content: _object_spread(_object_spread_props(_object_spread({}, style.content), {
                    overflow: "visible"
                }), minWidthProp)
            });
        });
        _this.state = {
            openModal: false,
            windowWidth: WINDOW_INITIAL_WIDTH,
            windowHeight: WINDOW_INITIAL_HEIGHT
        };
        _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeModal = _this.closeModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getVideoIconRenderer = _this.getVideoIconRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onPlayButtonClicked);
        return _this;
    }
    (0,_create_class/* default */.Z)(YouTubePopUpButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    windowHeight: window.innerHeight,
                    windowWidth: window.innerWidth
                });
            }
        },
        {
            key: "onPlayButtonClicked",
            value: function onPlayButtonClicked() {
                var _this = this;
                var videoId = this.props.videoId;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_OPEN_SECONDARY, {
                    kind: videoId
                });
                this.setState({
                    windowHeight: window.innerHeight - 100,
                    windowWidth: window.innerWidth - 100
                }, function() {
                    return _this.setState({
                        openModal: true
                    });
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                var videoId = this.props.videoId;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_CLOSE_SECONDARY, {
                    kind: videoId
                });
                this.setState({
                    openModal: false
                });
            }
        },
        {
            key: "getVideoIconRenderer",
            value: function getVideoIconRenderer(buttonDisplayType) {
                if (buttonDisplayType === button_consts/* REGULAR_BUTTON_TYPE */.ys) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        "aria-label": "Video button icon",
                        className: classnames_default()("play-wrapper", "regular-button"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(play, {})
                    });
                }
                var iconColor = this.props.iconColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "play-wrapper",
                    style: {
                        color: colors/* default */.Z[iconColor]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_play_core_button_v4, {})
                });
            }
        },
        {
            key: "renderButtonComponent",
            value: function renderButtonComponent() {
                var _this = this;
                var _props = this.props, buttonSize = _props.buttonSize, buttonDisplayType = _props.buttonDisplayType, buttonText = _props.buttonText, color = _props.color, isWithArrow = _props.isWithArrow, isWithIcon = _props.isWithIcon, isWithIconInsteadOfArrow = _props.isWithIconInsteadOfArrow, outline = _props.outline, minPadding = _props.minPadding, extraEventData = _props.extraEventData, withoutUnderline = _props.withoutUnderline;
                var buttonProps = {
                    buttonSize: buttonSize,
                    buttonText: buttonText,
                    isWithArrow: isWithArrow,
                    color: color,
                    iconRenderer: isWithIcon && function() {
                        return _this.getVideoIconRenderer(buttonDisplayType);
                    },
                    minPadding: minPadding,
                    onClick: this.onPlayButtonClicked,
                    isWithIconInsteadOfArrow: isWithIconInsteadOfArrow,
                    outline: outline,
                    extraEventData: extraEventData,
                    withoutUnderline: withoutUnderline
                };
                var ButtonComponent = buttonDisplayType === button_consts/* REGULAR_BUTTON_TYPE */.ys ? regular_button/* default */.Z : secondary_button/* default */.Z;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, _object_spread({}, buttonProps));
            }
        },
        {
            key: "render",
            value: function render() {
                var openModal = this.state.openModal;
                var videoId = this.props.videoId;
                var videoOpts = this.getVideoOpts();
                var modalStyle = this.getModalStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledYouTubePopUpButton, {
                    className: "you-tube-pop-up-button-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            tabIndex: 0,
                            onKeyDown: this.onKeyDown,
                            role: "button",
                            children: this.renderButtonComponent()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            videoId: videoId,
                            minHeight: MIN_HEIGHT,
                            isOpen: openModal,
                            opts: videoOpts,
                            onCloseModal: this.closeModal,
                            withSignup: false,
                            style: modalStyle
                        })
                    ]
                });
            }
        }
    ]);
    return YouTubePopUpButton;
}(react.PureComponent);
YouTubePopUpButton.defaultProps = youtube_popup_button_default_props/* default */.Z;
/* harmony default export */ var youtube_popup_button = ((0,generic_config_context/* withGenericConfig */.P)(YouTubePopUpButton));


/***/ }),

/***/ 20012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ baseFetch; },
/* harmony export */   "L": function() { return /* binding */ URL_BASE; }
/* harmony export */ });
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var URL_BASE = "https://monday.com";
var baseFetch = function(url, options) {
    return fetch(url, _object_spread({}, DEFAULT_FETCH_OPTIONS, options));
};
var DEFAULT_FETCH_OPTIONS = {
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
};


/***/ }),

/***/ 94445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Id": function() { return /* reexport */ analyzeContactSalesIntent; },
  "I9": function() { return /* reexport */ getCalendarLink; },
  "Cp": function() { return /* reexport */ isBC; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./services/base-fetch.js
var base_fetch = __webpack_require__(20012);
;// CONCATENATED MODULE: ./services/contact-sales/api-service.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var fetchData = function() {
    var _ref = _async_to_generator(function(url, body) {
        var method, timeout, controller, signal, timeoutId, response, errorText;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    method = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "POST", timeout = _arguments.length > 3 ? _arguments[3] : void 0;
                    controller = new AbortController();
                    signal = controller.signal;
                    timeoutId = timeout ? setTimeout(function() {
                        return controller.abort();
                    }, timeout) : null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        6,
                        7
                    ]);
                    return [
                        4,
                        (0,base_fetch/* baseFetch */.H)(url, {
                            method: method,
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body),
                            signal: signal
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 3:
                    errorText = _state.sent();
                    throw new Error("HTTP error ".concat(response.status, ": ").concat(errorText));
                case 4:
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    timeoutId && clearTimeout(timeoutId);
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchData(url, body) {
        return _ref.apply(this, arguments);
    };
}();
var isBC = function() {
    var _ref = _async_to_generator(function(email, timeout) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchData("".concat(base_fetch/* URL_BASE */.L, "/contact-sales/bc-qualify"), {
                            email: email,
                            timeout: timeout
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function isBC(email, timeout) {
        return _ref.apply(this, arguments);
    };
}();
var analyzeContactSalesIntent = function() {
    var _ref = _async_to_generator(function(prompt) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchData("".concat(base_fetch/* URL_BASE */.L, "/contact-sales/analyze-intent"), {
                            prompt: prompt
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function analyzeContactSalesIntent(prompt) {
        return _ref.apply(this, arguments);
    };
}();
var getCalendarLink = function() {
    var _ref = _async_to_generator(function(details, timeout) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchData("".concat(base_fetch/* URL_BASE */.L, "/contact-sales/calendar-link"), details, "POST", timeout)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCalendarLink(details, timeout) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./services/contact-sales/index.js



/***/ }),

/***/ 15650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c0": function() { return /* binding */ getCurrencyName; },
  "hU": function() { return /* binding */ getCurrencySign; },
  "$H": function() { return /* binding */ getCurrencyWithPriceDisplay; },
  "j": function() { return /* binding */ shouldSeeContactUs; },
  "zD": function() { return /* binding */ shouldShowCurrencyText; }
});

// UNUSED EXPORTS: AUD_COUNTRIES, CAD_COUNTRIES, EURO_COUNTRIES, GBP_COUNTRIES, JPY_COUNTRIES, PESO_COUNTRIES, REAL_COUNTRIES, USD_CURRENCY, getCurrencyData, getCurrencyShortText, setCurrencyCookie

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.scss.js

var StyledPriceWithCurrency = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "esqe350"
})("display:flex;align-items:flex-end;.currency-sign-and-text{display:inline-flex;flex-direction:column;align-items:center;margin-right:2%;margin-bottom:3%;.currency-sign-with-text{font-size:0.65em;}.currency-text{font-size:0.2em;font-weight:bold;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.js



var PriceWithCurrency = function(param) {
    var price = param.price, currency = param.currency, currencySign = param.currencySign, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceWithCurrency, {
        className: "price-with-currency",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "currency-sign-and-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-sign-with-text", className),
                        children: currencySign
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-text", className),
                        children: currency.toUpperCase()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: className,
                children: price
            })
        ]
    });
};
/* harmony default export */ var price_with_currency = (PriceWithCurrency);

;// CONCATENATED MODULE: ./services/pricing-service.js







var CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES = [
    localization.FRENCH_LOCALE_ID,
    localization.GERMAN_LOCALE_ID
];
var USD_CURRENCY = "usd";
var EURO_COUNTRIES = [
    "ad",
    "at",
    "be",
    "cy",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "ie",
    "it",
    "lv",
    "lt",
    "lu",
    "mt",
    "mc",
    "me",
    "nl",
    "pt",
    "sm",
    "sk",
    "si",
    "es",
    // NEW - starting from Jul 2022
    "al",
    "bh",
    "by",
    "ba",
    "bg",
    "hr",
    "cz",
    "dk",
    "eg",
    "fo",
    "ge",
    "gi",
    "hu",
    "is",
    "jo",
    "kw",
    "li",
    "mk",
    "md",
    "ma",
    "no",
    "om",
    "pl",
    "qa",
    "ro",
    "rs",
    "se",
    "ch",
    "sa",
    "tn",
    "tr",
    "ug",
    "ua",
    "ae",
    "va",
    "ye" // Yemen
];
var GBP_COUNTRIES = [
    "gb",
    "je",
    "gg",
    "im",
    "gs",
    "uk" // United Kingdom
];
var CAD_COUNTRIES = [
    "ca" // Canada
];
var AUD_COUNTRIES = [
    "au" // Australia
];
var PESO_COUNTRIES = [
    "mx" // Mexico
];
var REAL_COUNTRIES = [
    "br" // Brazil
];
var JPY_COUNTRIES = [
    "jp" // Japan
];
var CONTACT_US_THRESHOLD = 50;
var setCurrencyCookie = function setCurrencyCookie(currencyShortText) {
    (0,cookies_service/* setCookie */.d8)(cookies.CURRENCY_COOKIE_NAME, currencyShortText);
};
var getCurrencyFromCountry = function(country) {
    if (country) {
        var countryCode = country.toLowerCase();
        if (EURO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("eur");
            return "eur";
        }
        if (GBP_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("gbp");
            return "gbp";
        }
        if (CAD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("cad");
            return "cad";
        }
        if (AUD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("aud");
            return "aud";
        }
        if (PESO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("mxn");
            return "mxn";
        }
        if (REAL_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("brl");
            return "brl";
        }
        if (JPY_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("jpy");
            return "jpy";
        }
        //default to usd
        setCurrencyCookie("usd");
        return "usd";
    } else {
        //no country cookie - we return undefined and rely on the default configuration file
        //TODO: log an error? we are server side.
        return undefined;
    }
};
var getCurrency = function(forceCurrencyShortText, pricingDefaults, countryCode) {
    // first check query param exists.
    if (forceCurrencyShortText) {
        return forceCurrencyShortText;
    }
    if (countryCode) {
        return getCurrencyFromCountry(countryCode);
    }
    return (pricingDefaults === null || pricingDefaults === void 0 ? void 0 : pricingDefaults.defaultCurrency) || USD_CURRENCY;
};
var getCurrencyData = function getCurrencyData(currency) {
    var currenciesArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(currencyItem) {
        //find not supported in ie
        return currencyItem.name === currency;
    });
    return !currenciesArray || currenciesArray.length === 0 ? pricing/* SUPPORTED_CURRENCIES.0 */.ck[0] : currenciesArray[0];
};
var getCurrencyShortText = function getCurrencyShortText(currency) {
    var currencyData = getCurrencyData(currency);
    if (currencyData.shouldDisplayText) {
        return currencyData.currencyShortText;
    }
    return null;
};
var getCurrencyName = function(param) {
    var forceCurrency = param.forceCurrency, _pricingDefaults = param.pricingDefaults, pricingDefaults = _pricingDefaults === void 0 ? {} : _pricingDefaults, countryCode = param.countryCode;
    var shortCurrencyText = getCurrency(forceCurrency, pricingDefaults, countryCode);
    var currencyArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(supportedCurrency) {
        //find not supported in ie
        return supportedCurrency.currencyShortText.toLowerCase() === shortCurrencyText.toLowerCase();
    });
    return !currencyArray || currencyArray.length === 0 ? pricing/* SUPPORTED_CURRENCIES.0.name */.ck[0].name : currencyArray[0].name;
};
var getCurrencySign = function getCurrencySign(currency) {
    var currencyData = getCurrencyData(currency);
    return currencyData.currencySign;
};
var shouldShowCurrencyText = function(currency) {
    var lowerCaseCurrency = currency.toLowerCase();
    switch(lowerCaseCurrency){
        case "cad":
        case "aud":
        case "mxn":
            return true;
        default:
            return false;
    }
};
// For some locales, the currency sign (e.g. $) comes to the right of the price value.
var getCurrencyWithPriceDisplay = function(param) {
    var price = param.price, currency = param.currency, _localeId = param.localeId, localeId = _localeId === void 0 ? localization.ENGLISH_LOCALE_ID : _localeId, _hideCurrency = param.hideCurrency, hideCurrency = _hideCurrency === void 0 ? false : _hideCurrency, className = param.className;
    if (hideCurrency) {
        return price;
    }
    var currencySign = getCurrencySign(currency);
    var shouldShowCurrencyToTheRight = CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES.includes(localeId);
    if (!hideCurrency && shouldShowCurrencyText(currency)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_with_currency, {
            price: price,
            currency: currency,
            currencySign: currencySign,
            className: className
        });
    }
    return shouldShowCurrencyToTheRight ? "".concat(price, " ").concat(currencySign) : "".concat(currencySign).concat(price);
};
var getContactUsThreshold = function(param) {
    var clusterConfig = param.clusterConfig, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    if (!(0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) return CONTACT_US_THRESHOLD;
    return (clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_threshold) || CONTACT_US_THRESHOLD;
};
var shouldSeeContactUs = function shouldSeeContactUs(tier, usersCount) {
    var contactUsThresholdOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return tier === pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE || usersCount.includes("+") || Number(usersCount) >= getContactUsThreshold(contactUsThresholdOptions);
};


/***/ }),

/***/ 12403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CF": function() { return /* binding */ applyFreeUsersIfNeeded; },
/* harmony export */   "KX": function() { return /* binding */ applyDiscountIfNeeded; },
/* harmony export */   "pZ": function() { return /* binding */ shouldHideCrossedOutPrice; },
/* harmony export */   "qV": function() { return /* binding */ getMaxFreeUsersFromClusterConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69017);



var getDiscountFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount;
    }
};
var getFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing_users_count_options, _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var freeOptions = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : (_clusterConfig_payments_view_pricing_users_count_options = _clusterConfig_payments_view_pricing.users_count_options) === null || _clusterConfig_payments_view_pricing_users_count_options === void 0 ? void 0 : _clusterConfig_payments_view_pricing_users_count_options.free_options;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(freeOptions) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return freeOptions;
    }
};
var getMaxFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var freeOptions = getFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if ((freeOptions === null || freeOptions === void 0 ? void 0 : freeOptions.length) > 0) {
        var _Math;
        return (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(freeOptions));
    }
};
var applyDiscountIfNeeded = function(price, tier, period, clusterConfig, abTests, cookies, forcePricing) {
    var discount = getDiscountFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount)) return price;
    var value = discount.value, validTiers = discount.valid_tiers, validPeriods = discount.valid_periods;
    if (!value) return price;
    var isValidTier = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validTiers) || validTiers.includes(tier);
    var isValidPeriod = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validPeriods) || validPeriods.includes(period);
    var isDiscountValidForPlan = isValidTier && isValidPeriod;
    if (!isDiscountValidForPlan) return price;
    return price * (1 - value);
};
var applyFreeUsersIfNeeded = function(price, initialUsersCount, clusterConfig, abTests, cookies, forcePricing) {
    var usersCount = initialUsersCount;
    var maxFreeUsers = getMaxFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (maxFreeUsers > 0) {
        usersCount = initialUsersCount - maxFreeUsers;
    }
    return Math.max(price * usersCount, 0);
};
var shouldHideCrossedOutPrice = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount.hide_crossed_out_discount;
    }
    return false;
};


/***/ }),

/***/ 70533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ shouldShowYearlyPrices; },
/* harmony export */   "K": function() { return /* binding */ getPeriods; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69017);



var getClusterPeriodsConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var periods = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.periods;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(periods) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return periods;
    }
    return {};
};
var getPeriods = function(clusterConfig, abTests, cookies, forcePricing) {
    var periods = constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .ORDERED_PERIOD_NAMES */ .yv;
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var ref = clusterPeriodsConfig || {}, tmp = ref.hidden_periods, hiddenPeriods = tmp === void 0 ? [] : tmp;
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(hiddenPeriods) ? periods : periods.filter(function(period) {
        return !hiddenPeriods.includes(period);
    });
};
var shouldShowYearlyPrices = function(clusterConfig, abTests, cookies, forcePricing) {
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var display = clusterPeriodsConfig.display;
    return (display === null || display === void 0 ? void 0 : display.price_display) === constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .PERIODS.yearly */ .z5.yearly;
};


/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xS": function() { return /* binding */ getPricingModelService; },
  "rM": function() { return /* binding */ getPricingVersion; },
  "qM": function() { return /* binding */ getPricingVersionForSales; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./services/pricing/discounts-service.js
var discounts_service = __webpack_require__(12403);
// EXTERNAL MODULE: ./services/pricing/periods-service.js
var periods_service = __webpack_require__(70533);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/base-pricing-model-service.js





var BasePricingModelService = /*#__PURE__*/ function() {
    "use strict";
    function BasePricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BasePricingModelService);
    }
    (0,_create_class/* default */.Z)(BasePricingModelService, [
        {
            key: "getPlanPrice",
            value: function getPlanPrice(tier, currency, billingPeriod, userCount, pricingVersion, clusterConfig, abTests, cookies, forcePricing) {
                var hideDiscount = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : false;
                var prices = this.getPrices({
                    pricingVersion: pricingVersion
                });
                if (tier === pricing/* TIERS.FREE */.Iy.FREE) return 0;
                var basePrice = (0,discounts_service/* applyFreeUsersIfNeeded */.CF)(prices[billingPeriod][tier][currency], userCount, clusterConfig, abTests, cookies, forcePricing);
                var price = (0,periods_service/* shouldShowYearlyPrices */.B)(clusterConfig, abTests, cookies, forcePricing) ? basePrice * 12 : basePrice;
                return hideDiscount ? price : (0,discounts_service/* applyDiscountIfNeeded */.KX)(price, tier, billingPeriod, clusterConfig, abTests, cookies, forcePricing);
            }
        },
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                return "0";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return {};
            }
        },
        {
            key: "getPrices",
            value: function getPrices() {
                return [];
            }
        }
    ]);
    return BasePricingModelService;
}();


// EXTERNAL MODULE: ./services/pricing/product-prices.js
var product_prices = __webpack_require__(43331);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/buckets-pricing-model-service.js










var BucketsPricingModelService = /*#__PURE__*/ function(BasePricingModelService) {
    "use strict";
    (0,_inherits/* default */.Z)(BucketsPricingModelService, BasePricingModelService);
    var _super = (0,_create_super/* default */.Z)(BucketsPricingModelService);
    function BucketsPricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BucketsPricingModelService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BucketsPricingModelService, [
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getClusterUserOptions",
            value: function getClusterUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
                var clusterConfig = options.clusterConfig, abTests = options.abTests, forcePricing = options.forcePricing, cookies = options.cookies;
                var users_count_options = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.users_count_options;
                if (!isEmpty_default()(clusterConfig) && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
                    abTests: abTests,
                    forcePricing: forcePricing,
                    cookies: cookies
                })) {
                    return users_count_options === null || users_count_options === void 0 ? void 0 : users_count_options.all_options;
                }
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions[0];
                return "3";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions;
                return [
                    "3",
                    "5",
                    "10",
                    "15",
                    "20",
                    "25",
                    "30",
                    "40",
                    "50",
                    "100",
                    pricing/* MAX_TEAM_SIZE */.fY
                ];
            }
        },
        {
            key: "getPrices",
            value: function getPrices(param) {
                var _pricingVersion = param.pricingVersion, pricingVersion = _pricingVersion === void 0 ? (pricing_versions_default()).DEFAULT_VERSION : _pricingVersion;
                return product_prices/* productPrices.core */.A.core[pricingVersion];
            }
        }
    ]);
    return BucketsPricingModelService;
}(BasePricingModelService);


// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/services.js




var getPricingModelService = function(pricingVersion) {
    var _obj;
    var pricingModelsModelsMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_9, BucketsPricingModelService), (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_13, BucketsPricingModelService), (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_15, BucketsPricingModelService), _obj);
    var PricingModelService = pricingModelsModelsMapping[pricingVersion] || pricingModelsModelsMapping[(pricing_versions_default()).DEFAULT_VERSION];
    return new PricingModelService();
};
var getPricingVersion = function() {
    var forcePricing = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).forcePricing;
    if (forcePricing) {
        var forcePricingVersionNumberArray = forcePricing.match(/\d+(?:\.\d+)?/g);
        if (forcePricingVersionNumberArray.length > 0) {
            var forcePricingVersionNumber = forcePricingVersionNumberArray[0];
            if (pricing_versions_default().ALLOWED_VERSIONS.includes("".concat(forcePricingVersionNumber))) {
                return forcePricing;
            }
        }
    }
    return (pricing_versions_default()).DEFAULT_VERSION;
};
var getPricingVersionForSales = function(param) {
    var forcePricing = param.forcePricing, cookies = param.cookies, abTests = param.abTests, forceCurrency = param.forceCurrency, countryCode = param.countryCode;
    var currency = (0,pricing_service/* getCurrencyName */.c0)({
        forceCurrency: forceCurrency,
        countryCode: countryCode
    });
    return getPricingVersion({
        forcePricing: forcePricing,
        cookies: cookies,
        abTests: abTests,
        currency: currency
    });
};


/***/ }),

/***/ 85920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ getFirstTranslatedString; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "LZ": function() { return /* binding */ EMPTY_ARRAY; },
/* harmony export */   "RW": function() { return /* binding */ applyOverrides; },
/* harmony export */   "X2": function() { return /* binding */ runForEachTier; }
/* harmony export */ });
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47037);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55674);
/* harmony import */ var services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55551);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var isObject = function(value) {
    return typeof value === "object" && value !== null;
};
var runForEachTier = function(callback) {
    Object.keys(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy).forEach(function(tierKey) {
        return callback(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy[tierKey]);
    });
};
var EMPTY_ARRAY = []; // used in multiple places.
var getFirstTranslatedString = function(stringsArray) {
    if (!stringsArray || stringsArray.length === 0) return "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stringsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__[key]) {
                return key; // will be translated by the component.
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // couldn't find a translation for this value - treating it as a regular string, possibly enclosed in an array.
    if (Array.isArray(stringsArray)) {
        return "".concat(stringsArray[0]);
    }
    return "".concat(stringsArray);
};
var applyOverrides = function(originalObject, overridesObject, keys) {
    var returnedObject = _object_spread({}, originalObject);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var overrideValue = overridesObject === null || overridesObject === void 0 ? void 0 : overridesObject[key];
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_0___default()(overrideValue) || Array.isArray(overrideValue)) {
                returnedObject[key] = getFirstTranslatedString(overridesObject[key]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return returnedObject;
};


/***/ }),

/***/ 69017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LF": function() { return /* binding */ getPricingPageSectionsFromClusterConfig; },
  "vT": function() { return /* binding */ getTierDescriptionsFromClusterConfig; },
  "A2": function() { return /* binding */ getValueFeaturesFromClusterConfig; },
  "dn": function() { return /* binding */ isInClusterTest; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/tier-descriptions/index.js
var pricing_page_tier_descriptions = __webpack_require__(87529);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/default_sections.js
var default_sections = __webpack_require__(16168);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/features.js + 3 modules
var features = __webpack_require__(61980);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/clusters/marketing.js


var COMMUNICATION_ESSENTIALS = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return {
        sectionName: "pricingPage.features.sections.communication_essentials",
        features: [
            features.COMMUNICATION_WITH_CONTEXT,
            features.COLLABORATIVE_WHITEBOARD,
            features.INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            })
        ]
    };
};
var COLLABORATION_AND_SHARING_ESSENTIALS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.collaboration_and_sharing_essentials",
        features: [
            features.EMBED_DOCUMENTS_AND_BRIEFS,
            features.MARKETING_REQUESTS_WITH_FORMS,
            features.READY_MADE_MARKETING_TEMPLATES,
            features.DEADLINE_MANAGEMENT,
            features.SHARE_BOARD_WITH_EXTERNAL_GUESTS,
            features.UNLIMITED_VIEWERS,
            features.AUTOMATIONS,
            features.MARKETING_INTEGRATIONS,
            features.TIMELINE({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var INSIGHTS_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.insights_essentials",
    features: [
        features.MARKETING_DASHBOARDS,
        features.MARKETING_CALENDAR,
        features.DAILY_REPORTS
    ]
};
var MARKETING_OTHER_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.other_essentials",
    features: [
        features.IMPORT_EXPORT_EXCEL,
        features.UNLIMITED_BOARDS,
        features.ADVANCED_COLUMN_TYPES,
        features.MOBILE,
        features.ACTIVITY_LOG,
        features.ZOOM_INTEGRATION
    ]
};
var MARKETING_ADVANCED_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            features.KANBAN_VIEW,
            features.MAP,
            features.SEARCH,
            features.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            features.TIME_TRACKING,
            features.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            features.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            features.TAGS,
            features.PRIVATE_BOARDS
        ]
    };
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/free_tier_essentials.js
var free_tier_essentials = __webpack_require__(8876);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/default_essentials.js

var DEFAULT_ESSENTIALS = function(cookies, abTests) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            features.UNLIMITED_VIEWERS,
            features.UNLIMITED_BOARDS,
            features.UNLIMITED_DOCS,
            features.COLUMN_TYPES({
                cookies: cookies
            }),
            features.MOBILE,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            }),
            features.ACTIVITY_LOG
        ]
    };
};

;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/all_sections.js




var ESSENTIALS = function(param) {
    var abTests = param.abTests, cookies = param.cookies, hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return (0,free_tier_essentials/* getFreeTierEssentials */.b)(abTests, cookies);
    }
    return DEFAULT_ESSENTIALS(cookies, abTests);
};
var ALL_SECTIONS = {
    ESSENTIALS: ESSENTIALS,
    REMOTE_WORK_FEATURES_SECTION: default_sections/* REMOTE_WORK_FEATURES_SECTION */.RV,
    ADVANCED: default_sections/* ADVANCED */.UO,
    SECURITY: default_sections/* SECURITY */.lG,
    ADVANCED_REPORTING: default_sections/* ADVANCED_REPORTING */.k3,
    SUPPORT: default_sections/* SUPPORT */.wL,
    COMMUNICATION_ESSENTIALS: COMMUNICATION_ESSENTIALS,
    ADMINISTRATION_AND_CONTROL: default_sections/* ADMINISTRATION_AND_CONTROL */.Xn,
    SECURITY_NEW: default_sections/* SECURITY_NEW */._h,
    SUPPORT_NEW: default_sections/* SUPPORT_NEW */.QA,
    COLLABORATION_AND_SHARING_ESSENTIALS: COLLABORATION_AND_SHARING_ESSENTIALS,
    INSIGHTS_ESSENTIALS: INSIGHTS_ESSENTIALS,
    MARKETING_OTHER_ESSENTIALS: MARKETING_OTHER_ESSENTIALS,
    MARKETING_ADVANCED_SECTION: MARKETING_ADVANCED_SECTION,
    CUSTOMER_FAVORITES: default_sections/* CUSTOMER_FAVORITES */.Kk,
    COLLABORATION: default_sections/* COLLABORATION */.iz,
    PRODUCTIVITY: default_sections/* PRODUCTIVITY */.nD,
    VIEWS_AND_REPORTING: default_sections/* VIEWS_AND_REPORTING */.uK,
    SECURITY_AND_PRIVACY: default_sections/* SECURITY_AND_PRIVACY */.K8,
    ENTERPRISE_REPORTING_AND_ANALYTICS: default_sections/* ENTERPRISE_REPORTING_AND_ANALYTICS */.zw
};
/* harmony default export */ var all_sections = (ALL_SECTIONS);

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-helper-service.js
var clusterized_pricing_page_helper_service = __webpack_require__(85920);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-features-service.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_FEATURE_KEYS = [
    "name",
    "description"
];
var DEFAULT_SECTION_KEYS = [
    "sectionName"
];
var isFeatureValid = function(feature) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_FEATURE_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(feature[key]) || feature[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!feature.tiers || Object.keys(feature.tiers).length === 0) return false;
    return true;
};
var isSectionValid = function(section) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_SECTION_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(section[key]) || section[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!section.features || section.features.length === 0) return false;
    return true;
};
var convertStringToFeatureTierValue = function(stringValue) {
    if (!stringValue) return false;
    if (stringValue == "true") return true;
    return (0,clusterized_pricing_page_helper_service/* getFirstTranslatedString */.Am)(clusterized_pricing_page_helper_service/* EMPTY_ARRAY.concat */.LZ.concat(stringValue));
};
var getFeatureTierValue = function(tier, tiersObject, feature) {
    if (tiersObject && tiersObject[tier]) {
        return {
            value: convertStringToFeatureTierValue(tiersObject[tier])
        };
    } else if (tier === pricing/* TIERS.FREE */.Iy.FREE) {
        // free tier gets, by default, the value of the basic tier, unless defined otherwise.
        return getFeatureTierValue(pricing/* TIERS.BASIC */.Iy.BASIC, tiersObject, feature);
    } else if (!(feature === null || feature === void 0 ? void 0 : feature.tiers[tier])) {
        // no value defined for this tier, and it's a new feature
        return {
            value: false
        };
    }
    return feature.tiers[tier];
};
var generateDefaultTiersObject = function() {
    var tiersObject = {};
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        tiersObject[tier] = {
            value: false
        };
    });
    return tiersObject;
};
/**
 * Retrieves a feature's default values by that feature's name, and returns those values as a feature object.
 * @param {*} featureName - assumed to be uppercased, to match the constant.
 * @param {*} abTests - for features whose default value depends on A/B test variants.
 * @param {*} cookies - for features whose default value depends on cookies.
 */ var getExistingFeature = function(featureName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (typeof features[featureName] === "function") {
        return features[featureName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }
    var feature = features[featureName];
    return feature ? _object_spread({}, feature) : null;
};
var convertFeature = function(featureNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(featureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code feature, it will be used.
        var feature = getExistingFeature(featureNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!feature) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "features",
                data: featureNameOrObject
            });
            return null;
        }
        return feature;
    }
    // got an object - verifying that it has a name (either an existing feature's or an override)
    var feature1 = featureNameOrObject.feature, featureName = featureNameOrObject.featureName, overrides = featureNameOrObject.overrides; // 'featureName' for backwards compatibility - TODO remove after fixing existing configs.
    if (!feature1 && !featureName && !(overrides === null || overrides === void 0 ? void 0 : overrides.name)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            kind: "object",
            placement: "features",
            data: featureNameOrObject
        });
        return null; // must have either an existing feature's name, or a new one.
    }
    // overriding name and description:
    var existingFeature = getExistingFeature(feature1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingFeature(featureName, {
        abTests: abTests,
        cookies: cookies,
        hasFreeTier: hasFreeTier,
        hasStudentPlan: hasStudentPlan
    }) || {}; // using an existing feature if one matches the name. Features can be identified either by 'feature' or 'featureName'.
    var featureWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, featureNameOrObject === null || featureNameOrObject === void 0 ? void 0 : featureNameOrObject.overrides, DEFAULT_FEATURE_KEYS);
    // overriding tiers:
    var tiers = (overrides || {}).tiers;
    if (!featureWithOverrides.tiers) {
        // new feature - no tiers defined
        featureWithOverrides.tiers = generateDefaultTiersObject();
    }
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        featureWithOverrides.tiers[tier] = getFeatureTierValue(tier, tiers, featureWithOverrides);
    });
    if (!isFeatureValid(featureWithOverrides)) return null;
    return featureWithOverrides;
};
/**
 * Retrieves a section's default values (name and features list) by that section's name, and returns those as a
 * section object.
 * @param {*} sectionName
 * @param {*} abTests - in case the section data depends on AB tests.
 * @param {*} cookies - in case the section data depends on cookies.
 */ var getExistingSection = function(sectionName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    var originalSection;
    if (typeof all_sections[sectionName] === "function") {
        originalSection = all_sections[sectionName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    } else {
        originalSection = all_sections[sectionName];
    }
    return originalSection ? _object_spread({}, originalSection) : null;
};
var convertSection = function(sectionNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(sectionNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code section, that section will be used.
        var section = getExistingSection(sectionNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!section) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "sections",
                data: sectionNameOrObject
            });
            return null;
        }
        return section;
    }
    // creating a section object using the given input
    var section1 = sectionNameOrObject.section, sectionName = sectionNameOrObject.sectionName, overrides = sectionNameOrObject.overrides; // 'sectionName' for backwards compatibility - TODO remove after fixing existing configs
    if (!section1 && !sectionName && !(overrides === null || overrides === void 0 ? void 0 : overrides.sectionName)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            placement: "sections",
            kind: "object",
            data: sectionNameOrObject
        });
        return null; // must have an existing section's name, or a new one.
    }
    var existingSection = getExistingSection(section1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingSection(sectionName, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || {}; // using an existing section if one matches the name.
    var sectionWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingSection, overrides, DEFAULT_SECTION_KEYS);
    if (!sectionWithOverrides.features) {
        sectionWithOverrides.features = [];
    }
    if (overrides === null || overrides === void 0 ? void 0 : overrides.features) {
        sectionWithOverrides.features = compact_default()(overrides.features.map(function(feature) {
            return convertFeature(feature, {
                abTests: abTests,
                cookies: cookies,
                hasStudentPlan: hasStudentPlan,
                hasFreeTier: hasFreeTier
            });
        }));
    }
    if (!isSectionValid(sectionWithOverrides)) return null;
    return sectionWithOverrides;
};
var convertSectionToPricingPageSection = function(value, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return convertSection(value, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/value-features/index.js
var value_features = __webpack_require__(69078);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var features_value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-value-features-service.js
function clusterized_pricing_page_value_features_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_value_features_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_value_features_service_define_property(target, key, source[key]);
        });
    }
    return target;
}








var isValueFeatureValid = function(valueFeature) {
    return isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.name) && isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.text) && valueFeature.name.length > 0 && valueFeature.text.length > 0;
};
var getExistingValueFeature = function(valueFeatureName) {
    if (isValueFeatureValid(features_value_features[valueFeatureName])) {
        return clusterized_pricing_page_value_features_service_object_spread({}, features_value_features[valueFeatureName]);
    }
    return null;
};
var getValueFeatureOrNull = function(valueFeatureNameOrObject) {
    if (isString_default()(valueFeatureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code value feature, it will be used.
        var valueFeature = getExistingValueFeature(valueFeatureNameOrObject);
        if (!valueFeature) {
            // missing value feature - emitting event
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "name",
                data: valueFeatureNameOrObject
            });
        }
        return valueFeature; // will be null if no such value feature exists.
    } else if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(valueFeatureNameOrObject)) {
        var feature = valueFeatureNameOrObject.feature, name = valueFeatureNameOrObject.name, overrides = valueFeatureNameOrObject.overrides; // 'name' is there for backwards compatibility - TODO remove
        var existingFeature = getExistingValueFeature(feature) || getExistingValueFeature(name) || {};
        var overrideKeys = [
            "name",
            "text",
            "link"
        ];
        var resultingFeature = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, overrides, overrideKeys);
        if (!isValueFeatureValid(resultingFeature)) {
            // no source for the value feature's name and text (either a code-based existing feature or config-delivered) -
            // returning null.
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "object",
                data: valueFeatureNameOrObject
            });
            return null;
        }
        return resultingFeature;
    }
    // value must be a string or an object.
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
        placement: "value_features",
        kind: "invalid_type",
        data: valueFeatureNameOrObject
    });
    return null;
};
var getClusterizedValueFeatures = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var valueFeaturesObject = clusterized_pricing_page_value_features_service_object_spread({}, (0,value_features/* DEFAULT_VALUE_FEATURES_PER_TIER */.S)({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    }));
    // overriding default values (using existing value features) on a per-tier basis
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        if (tier === pricing/* TIERS.FREE */.Iy.FREE) return;
        // the Individual plan top features aren't shown at the moment, since it's a reduced, controlled plan.
        var tierClusterFeatures = clusterValueFeatures[tier];
        if (Array.isArray(tierClusterFeatures) && tierClusterFeatures.length > 0) {
            valueFeaturesObject[tier] = compact_default()(tierClusterFeatures.map(getValueFeatureOrNull));
        }
    });
    return valueFeaturesObject;
};

;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js
function clusterized_pricing_page_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_service_define_property(target, key, source[key]);
        });
    }
    return target;
}









var isInClusterTest = function(clusterConfig, param) {
    var abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return true;
    return false;
    if (!(clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view)) return false; // no payments config -> no AB test
    var abTestConfig = (clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view).abTestConfig;
    if (!(abTestConfig === null || abTestConfig === void 0 ? void 0 : abTestConfig.homepage)) return true; // cluster pricing config is active by default if there isn't a homepage test
    var _homepage = abTestConfig.homepage, disableTest = _homepage.disableTest, testName = _homepage.testName, newVariationName = _homepage.newVariationName, sendBigBrainEvent = _homepage.sendBigBrainEvent, syncCookieName = _homepage.syncCookieName, syncCookieValue = _homepage.syncCookieValue, homepageSyncCookieName = _homepage.homepageSyncCookieName, configForcePricing = _homepage.forcePricing;
    // checking: the test was manually disabled for now
    if (disableTest === "true" || disableTest === true) {
        return true;
    }
    // checking: 'forcePricing' value was passed
    if (configForcePricing && configForcePricing === forcePricing) {
        return true;
    }
    // checking: the user already received a platform variant
    // TODO return after caching issues have been fully cleared
    if (cookies) {
        var matchingPlatformCookie = cookies[syncCookieName];
        if (matchingPlatformCookie && syncCookieValue && matchingPlatformCookie === syncCookieValue) {
            // otherwise, undefined === undefined.
            return true; // achieved via platform <--> homepage test synchronization.
        }
    }
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, testName, sendBigBrainEvent);
    // if we want to synchronize the homepage's AB test result to the platform:
    // TODO return after caching issues have been fully cleared
    if (isString_default()(homepageSyncCookieName) && isString_default()(abTestVariant)) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(homepageSyncCookieName, abTestVariant);
    }
    return abTestVariant === newVariationName;
};
// Expected input:
// { sections:
//  ([ESSENTIALS, ...] or [{sectionName: 'ESSENTIALS', overrides: ...}])
// }
var getPricingPageSectionsFromClusterConfig = function(pricingConfig, param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? {} : _abTests, _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _hasStudentPlan = param.hasStudentPlan, hasStudentPlan = _hasStudentPlan === void 0 ? false : _hasStudentPlan, _hasFreeTier = param.hasFreeTier, hasFreeTier = _hasFreeTier === void 0 ? false : _hasFreeTier;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !Array.isArray(pricingConfig.sections)) return;
    var sections = pricingConfig.sections;
    return compact_default()(sections.map(function(section) {
        return convertSectionToPricingPageSection(section, {
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }));
};
var getTierDescriptionsFromClusterConfig = function(pricingConfig, clusterId, param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies, abTests = param.abTests, forcePricing = param.forcePricing;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig.tier_descriptions)) return;
    // getting default tier descriptions
    var tier_descriptions = pricingConfig.tier_descriptions;
    var returnedDescriptions = clusterized_pricing_page_service_object_spread({}, (0,pricing_page_tier_descriptions/* getDefaultTierDescriptions */.O)({
        hasStudentPlan: hasStudentPlan
    }));
    // overriding them if any exist
    if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(tier_descriptions)) {
        (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
            if (tier === pricing/* TIERS.FREE */.Iy.FREE) return; // Individual plan sees the same descriptions regardless of cluster.
            if (isString_default()(tier_descriptions[tier])) {
                returnedDescriptions[tier] = tier_descriptions[tier];
            }
        });
    }
    return returnedDescriptions;
};
var getValueFeaturesFromClusterConfig = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies;
    if (!clusterValueFeatures || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(clusterValueFeatures)) return;
    return getClusterizedValueFeatures(clusterValueFeatures, {
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies
    });
};


/***/ }),

/***/ 43331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ productPrices; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78803);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__);


var free = {
    usd: 0,
    euro: 0,
    gbp: 0,
    cad: 0,
    aud: 0,
    brl: 0,
    mxn: 0,
    inr: 0,
    jpy: 0
};
var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
var productPrices = {
    core: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 2200
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 1800
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 37,
                mxn: 150,
                inr: 550,
                jpy: 850
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 60,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 27,
                euro: 27,
                gbp: 23,
                cad: 37,
                aud: 37,
                brl: 135,
                mxn: 540,
                inr: 2000,
                jpy: 3000
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 700
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 50,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 22,
                euro: 22,
                gbp: 19,
                cad: 30,
                aud: 30,
                brl: 110,
                mxn: 440,
                inr: 1650,
                jpy: 2500
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 3300
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 2700
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 108,
                mxn: 475,
                inr: 1780,
                jpy: 3300
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1425,
                jpy: 2700
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 49,
                mxn: 240,
                inr: 890,
                jpy: 1530
            },
            standard: {
                usd: 14,
                euro: 14,
                gbp: 13,
                cad: 20,
                aud: 20,
                brl: 65,
                mxn: 280,
                inr: 1060,
                jpy: 1990
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 105,
                mxn: 480,
                inr: 1770,
                jpy: 3890
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 47,
                cad: 73,
                aud: 73,
                brl: 255,
                mxn: 1080,
                inr: 4070,
                jpy: 8700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 9,
                euro: 9,
                gbp: 8,
                cad: 13,
                aud: 13,
                brl: 41,
                mxn: 190,
                inr: 600,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 53,
                mxn: 240,
                inr: 800,
                jpy: 1650
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1250,
                jpy: 3200
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 39,
                cad: 60,
                aud: 60,
                brl: 210,
                mxn: 900,
                inr: 3400,
                jpy: 7200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_15, {
        monthly: {
            free: free,
            basic: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 19,
                brl: 66,
                mxn: 240,
                inr: 890,
                jpy: 1530
            },
            standard: {
                usd: 14,
                euro: 14,
                gbp: 13,
                cad: 20,
                aud: 22,
                brl: 77,
                mxn: 280,
                inr: 1060,
                jpy: 1990
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 39,
                brl: 132,
                mxn: 480,
                inr: 1770,
                jpy: 3890
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 47,
                cad: 73,
                aud: 87,
                brl: 297,
                mxn: 1080,
                inr: 4070,
                jpy: 8700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 9,
                euro: 9,
                gbp: 8,
                cad: 13,
                aud: 14,
                brl: 50,
                mxn: 190,
                inr: 600,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 19,
                brl: 66,
                mxn: 240,
                inr: 800,
                jpy: 1650
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 30,
                brl: 105,
                mxn: 380,
                inr: 1250,
                jpy: 3200
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 39,
                cad: 60,
                aud: 82.3,
                brl: 286,
                mxn: 900,
                inr: 3400,
                jpy: 7200
            }
        }
    }), _obj),
    marketing: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), _obj1),
    crm: (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 4,
                aud: 4,
                brl: 16,
                mxn: 60,
                inr: 210,
                jpy: 330
            },
            standard: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 29,
                mxn: 120,
                inr: 440,
                jpy: 680
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 10,
                cad: 16,
                aud: 16,
                brl: 59,
                mxn: 220,
                inr: 880,
                jpy: 1330
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 5,
                aud: 3,
                brl: 12,
                mxn: 40,
                inr: 200,
                jpy: 260
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 3,
                cad: 6,
                aud: 6,
                brl: 24,
                mxn: 90,
                inr: 350,
                jpy: 530
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 7,
                cad: 13,
                aud: 13,
                brl: 46,
                mxn: 180,
                inr: 600,
                jpy: 1050
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_15, {
        monthly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 4,
                aud: 5,
                brl: 17,
                mxn: 60,
                inr: 210,
                jpy: 330
            },
            standard: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 10,
                brl: 33,
                mxn: 120,
                inr: 440,
                jpy: 680
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 10,
                cad: 16,
                aud: 14,
                brl: 50,
                mxn: 220,
                inr: 880,
                jpy: 1330
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: 23,
                brl: 160,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 5,
                aud: 5,
                brl: 16,
                mxn: 40,
                inr: 200,
                jpy: 260
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 3,
                cad: 6,
                aud: 8,
                brl: 28,
                mxn: 90,
                inr: 350,
                jpy: 530
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 7,
                cad: 13,
                aud: 15,
                brl: 49,
                mxn: 180,
                inr: 600,
                jpy: 1050
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: 6.7,
                brl: 72,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        }
    }), _obj2),
    projectManagement: (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), _obj3),
    software: (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 4,
                mxn: 0,
                inr: 10,
                jpy: -5
            },
            standard: {
                usd: 0.5,
                euro: 0.5,
                gbp: 0,
                cad: 0.3,
                aud: 0.3,
                brl: 2,
                mxn: 10,
                inr: 28,
                jpy: -10
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 1,
                cad: 1.6,
                aud: 1.6,
                brl: 10,
                mxn: 20,
                inr: 105,
                jpy: -30
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.2,
                cad: -0.7,
                aud: -0.7,
                brl: -1,
                mxn: -10,
                inr: 0,
                jpy: -85
            },
            standard: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 2,
                mxn: 0,
                inr: 0,
                jpy: -25
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 0,
                cad: 1.3,
                aud: 1.3,
                brl: 6,
                mxn: 20,
                inr: 100,
                jpy: -50
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_15, {
        monthly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: 0,
                brl: 0,
                mxn: 0,
                inr: 10,
                jpy: -5
            },
            standard: {
                usd: 0.5,
                euro: 0.5,
                gbp: 0,
                cad: 0.3,
                aud: 1,
                brl: 3,
                mxn: 10,
                inr: 28,
                jpy: -10
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 1,
                cad: 1.6,
                aud: 1,
                brl: 6,
                mxn: 20,
                inr: 105,
                jpy: -30
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: -27,
                brl: -55,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.2,
                cad: -0.7,
                aud: 0,
                brl: 0,
                mxn: -10,
                inr: 0,
                jpy: -85
            },
            standard: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: 0,
                brl: 0,
                mxn: 0,
                inr: 0,
                jpy: -25
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 0,
                cad: 1.3,
                aud: 2,
                brl: 5,
                mxn: 20,
                inr: 100,
                jpy: -50
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: -34.3,
                brl: -93,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        }
    }), _obj4),
    service: (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            standard: {
                usd: 15,
                euro: 15,
                gbp: 12,
                cad: 19,
                aud: 19,
                brl: 61,
                mxn: 300,
                inr: 1115,
                jpy: 1997
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 17,
                cad: 27,
                aud: 27,
                brl: 87,
                mxn: 400,
                inr: 1530,
                jpy: 2160
            },
            enterprise: free
        },
        yearly: {
            standard: {
                usd: 14,
                euro: 14,
                gbp: 12,
                cad: 18,
                aud: 18,
                brl: 60,
                mxn: 280,
                inr: 950,
                jpy: 1925
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 16,
                cad: 26,
                aud: 26,
                brl: 77,
                mxn: 380,
                inr: 1250,
                jpy: 2025
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_15, {
        monthly: {
            standard: {
                usd: 15,
                euro: 15,
                gbp: 12,
                cad: 19,
                aud: 24,
                brl: 83,
                mxn: 300,
                inr: 1115,
                jpy: 1997
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 17,
                cad: 27,
                aud: 31,
                brl: 110,
                mxn: 400,
                inr: 1530,
                jpy: 2160
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: 7,
                brl: 83,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        },
        yearly: {
            standard: {
                usd: 14,
                euro: 14,
                gbp: 12,
                cad: 18,
                aud: 23,
                brl: 77,
                mxn: 280,
                inr: 950,
                jpy: 1925
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 16,
                cad: 26,
                aud: 31,
                brl: 104,
                mxn: 380,
                inr: 1250,
                jpy: 2025
            },
            enterprise: {
                usd: 0,
                euro: 0,
                gbp: 0,
                cad: 0,
                aud: -0.3,
                brl: 44,
                mxn: 0,
                inr: 0,
                jpy: 0
            }
        }
    }), _obj5)
};


/***/ }),

/***/ 29919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ StoreUTMDataForEnrichment; },
/* harmony export */   "Xk": function() { return /* binding */ getEnrichmentEntriesForSales; },
/* harmony export */   "uC": function() { return /* binding */ storeNumberOfSeats; }
/* harmony export */ });
/* unused harmony export getSingleEnrichmentEntry */
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8339);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22638);
/* harmony import */ var client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53989);



var getSingleEnrichmentEntry = function(paramName, hubspotApiName) {
    var _localStorage;
    var paramValue = JSON.parse(((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(paramName)) || "null");
    if (paramValue) {
        var value = paramValue.value;
        return {
            name: hubspotApiName,
            value: value
        };
    }
};
var getEnrichmentEntriesForSales = function() {
    try {
        var enrichmentEntries = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_LIST */ .zj[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var paramName = item.paramName, hubspotApiName = item.hubspotApiName;
                var singleEnrichmentEntry = getSingleEnrichmentEntry(paramName, hubspotApiName);
                if (singleEnrichmentEntry) {
                    enrichmentEntries.push(singleEnrichmentEntry);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return enrichmentEntries;
    } catch (e) {
        (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__/* .handleClientException */ .N)({
            e: e
        });
        return [];
    }
};
var storeEnrichmentParamInLocalStorage = function(param) {
    var paramName = param.paramName, paramValue = param.paramValue;
    var _localStorage;
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(paramName, JSON.stringify({
        value: paramValue,
        timestamp: Date.now()
    }));
};
var storeUtmDataFromUrl = function() {
    var salesEnrichementUrlParamList = client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_LIST.filter */ .zj.filter(function(item) {
        return item.type === client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM */ .sD.URL_PARAM;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = salesEnrichementUrlParamList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var paramName = item.paramName;
            var paramValue = (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getDecodedParamFromQuery)(window.location, paramName);
            if (paramValue) {
                storeEnrichmentParamInLocalStorage({
                    paramName: paramName,
                    paramValue: paramValue
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var storeNumberOfSeats = function(numberOfSeats) {
    storeEnrichmentParamInLocalStorage({
        paramName: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .NUMBER_OF_SEATS_PARAM */ .AB,
        paramValue: numberOfSeats
    });
};
var StoreUTMDataForEnrichment = function() {
    try {
        storeUtmDataFromUrl();
    } catch (e) {
        (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__/* .handleClientException */ .N)({
            e: e
        });
    }
};


/***/ })

}]);